/**
 * Generated by orval v7.0.1 🍺
 * Do not edit manually.
 * Dev API
 * OpenAPI spec version: 0.0.1
 */
import useSwr from 'swr'
import type {
  Arguments,
  Key,
  SWRConfiguration
} from 'swr'
import useSWRMutation from 'swr/mutation'
import type {
  SWRMutationConfiguration
} from 'swr/mutation'
import type {
  AvatarListResponseResponse,
  AvatarNotFoundResponseResponse,
  AvatarPatchRequestBodyBody,
  AvatarRequestBodyBody,
  AvatarResponseResponse,
  CategoryListResponseResponse,
  CategoryNotFoundResponseResponse,
  CategoryPatchRequestBodyBody,
  CategoryRequestBodyBody,
  CategoryResponseResponse,
  CreateAvatarParams,
  CreateCategoryParams,
  CreateIconParams,
  CreateImageParams,
  CreateMemberParams,
  CreateModelParams,
  CreatePayloadKvParams,
  CreatePayloadLockedDocumentParams,
  CreatePayloadMigrationParams,
  CreatePayloadPreferenceParams,
  CreatePhotoParams,
  CreatePremiumSubscriptionParams,
  CreateStatsParams,
  CreateTagParams,
  CreateTokenUtilityParams,
  CreateUserParams,
  DeleteAvatarParams,
  DeleteCategoryParams,
  DeleteIconParams,
  DeleteImageParams,
  DeleteMemberParams,
  DeleteModelParams,
  DeletePayloadKvParams,
  DeletePayloadLockedDocumentParams,
  DeletePayloadMigrationParams,
  DeletePayloadPreferenceParams,
  DeletePhotoParams,
  DeletePremiumSubscriptionParams,
  DeleteStatsParams,
  DeleteTagParams,
  DeleteTokenUtilityParams,
  DeleteUserParams,
  FindAvatarByIdParams,
  FindCategoryByIdParams,
  FindIconByIdParams,
  FindImageByIdParams,
  FindMemberByIdParams,
  FindModelByIdParams,
  FindPayloadKvByIdParams,
  FindPayloadLockedDocumentByIdParams,
  FindPayloadMigrationByIdParams,
  FindPayloadPreferenceByIdParams,
  FindPhotoByIdParams,
  FindPremiumSubscriptionByIdParams,
  FindStatsByIdParams,
  FindTagByIdParams,
  FindTokenUtilityByIdParams,
  FindUserByIdParams,
  GetApiGlobalsSettingsParams,
  IconListResponseResponse,
  IconNotFoundResponseResponse,
  IconPatchRequestBodyBody,
  IconRequestBodyBody,
  IconResponseResponse,
  ImageListResponseResponse,
  ImageNotFoundResponseResponse,
  ImagePatchRequestBodyBody,
  ImageRequestBodyBody,
  ImageResponseResponse,
  ListAvatarsParams,
  ListCategoriesParams,
  ListIconsParams,
  ListImagesParams,
  ListMembersParams,
  ListModelsParams,
  ListPayloadKvsParams,
  ListPayloadLockedDocumentsParams,
  ListPayloadMigrationsParams,
  ListPayloadPreferencesParams,
  ListPhotosParams,
  ListPremiumSubscriptionsParams,
  ListStatsParams,
  ListTagsParams,
  ListTokenUtilitiesParams,
  ListUsersParams,
  MemberListResponseResponse,
  MemberNotFoundResponseResponse,
  MemberPatchRequestBodyBody,
  MemberRequestBodyBody,
  MemberResponseResponse,
  ModelListResponseResponse,
  ModelNotFoundResponseResponse,
  ModelPatchRequestBodyBody,
  ModelRequestBodyBody,
  ModelResponseResponse,
  NewAvatarResponseResponse,
  NewCategoryResponseResponse,
  NewIconResponseResponse,
  NewImageResponseResponse,
  NewMemberResponseResponse,
  NewModelResponseResponse,
  NewPayloadKvResponseResponse,
  NewPayloadLockedDocumentResponseResponse,
  NewPayloadMigrationResponseResponse,
  NewPayloadPreferenceResponseResponse,
  NewPhotoResponseResponse,
  NewPremiumSubscriptionResponseResponse,
  NewStatsResponseResponse,
  NewTagResponseResponse,
  NewTokenUtilityResponseResponse,
  NewUserResponseResponse,
  PayloadKvListResponseResponse,
  PayloadKvNotFoundResponseResponse,
  PayloadKvPatchRequestBodyBody,
  PayloadKvRequestBodyBody,
  PayloadKvResponseResponse,
  PayloadLockedDocumentListResponseResponse,
  PayloadLockedDocumentNotFoundResponseResponse,
  PayloadLockedDocumentPatchRequestBodyBody,
  PayloadLockedDocumentRequestBodyBody,
  PayloadLockedDocumentResponseResponse,
  PayloadMigrationListResponseResponse,
  PayloadMigrationNotFoundResponseResponse,
  PayloadMigrationPatchRequestBodyBody,
  PayloadMigrationRequestBodyBody,
  PayloadMigrationResponseResponse,
  PayloadPreferenceListResponseResponse,
  PayloadPreferenceNotFoundResponseResponse,
  PayloadPreferencePatchRequestBodyBody,
  PayloadPreferenceRequestBodyBody,
  PayloadPreferenceResponseResponse,
  PhotoListResponseResponse,
  PhotoNotFoundResponseResponse,
  PhotoPatchRequestBodyBody,
  PhotoRequestBodyBody,
  PhotoResponseResponse,
  PremiumSubscriptionListResponseResponse,
  PremiumSubscriptionNotFoundResponseResponse,
  PremiumSubscriptionPatchRequestBodyBody,
  PremiumSubscriptionRequestBodyBody,
  PremiumSubscriptionResponseResponse,
  SettingsRequestBodyBody,
  SettingsResponseResponse,
  StatsListResponseResponse,
  StatsNotFoundResponseResponse,
  StatsPatchRequestBodyBody,
  StatsRequestBodyBody,
  StatsResponseResponse,
  TagListResponseResponse,
  TagNotFoundResponseResponse,
  TagPatchRequestBodyBody,
  TagRequestBodyBody,
  TagResponseResponse,
  TokenUtilityListResponseResponse,
  TokenUtilityNotFoundResponseResponse,
  TokenUtilityPatchRequestBodyBody,
  TokenUtilityRequestBodyBody,
  TokenUtilityResponseResponse,
  UpdateAvatarParams,
  UpdateCategoryParams,
  UpdateIconParams,
  UpdateImageParams,
  UpdateMemberParams,
  UpdateModelParams,
  UpdatePayloadKvParams,
  UpdatePayloadLockedDocumentParams,
  UpdatePayloadMigrationParams,
  UpdatePayloadPreferenceParams,
  UpdatePhotoParams,
  UpdatePremiumSubscriptionParams,
  UpdateStatsParams,
  UpdateTagParams,
  UpdateTokenUtilityParams,
  UpdateUserParams,
  UserListResponseResponse,
  UserNotFoundResponseResponse,
  UserPatchRequestBodyBody,
  UserRequestBodyBody,
  UserResponseResponse
} from '../_models'
import { apiClient } from '../base';



  
  type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];

/**
 * @summary Retrieve a list of Avatars
 */
export const listAvatars = (
    params?: ListAvatarsParams,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<AvatarListResponseResponse>(
    {url: `/api/userAvatars`, method: 'GET',
        params
    },
    options);
  }



export const getListAvatarsKey = (params?: ListAvatarsParams,) => [`/api/userAvatars`, ...(params ? [params]: [])] as const;

export type ListAvatarsQueryResult = NonNullable<Awaited<ReturnType<typeof listAvatars>>>
export type ListAvatarsQueryError = unknown

/**
 * @summary Retrieve a list of Avatars
 */
export const useListAvatars = <TError = unknown>(
  params?: ListAvatarsParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof listAvatars>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof apiClient> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getListAvatarsKey(params) : null);
  const swrFn = () => listAvatars(params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Create a new Avatar
 */
export const createAvatar = (
    avatarRequestBodyBody: AvatarRequestBodyBody,
    params?: CreateAvatarParams,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<NewAvatarResponseResponse>(
    {url: `/api/userAvatars`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: avatarRequestBodyBody,
        params
    },
    options);
  }



export const getCreateAvatarMutationFetcher = (params?: CreateAvatarParams, options?: SecondParameter<typeof apiClient>) => {
  return (_: Key, { arg }: { arg: AvatarRequestBodyBody }): Promise<NewAvatarResponseResponse> => {
    return createAvatar(arg, params, options);
  }
}
export const getCreateAvatarMutationKey = (params?: CreateAvatarParams,) => [`/api/userAvatars`, ...(params ? [params]: [])] as const;

export type CreateAvatarMutationResult = NonNullable<Awaited<ReturnType<typeof createAvatar>>>
export type CreateAvatarMutationError = unknown

/**
 * @summary Create a new Avatar
 */
export const useCreateAvatar = <TError = unknown>(
  params?: CreateAvatarParams, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof createAvatar>>, TError, Key, AvatarRequestBodyBody, Awaited<ReturnType<typeof createAvatar>>> & { swrKey?: string }, request?: SecondParameter<typeof apiClient>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getCreateAvatarMutationKey(params);
  const swrFn = getCreateAvatarMutationFetcher(params, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Find a Avatar by ID
 */
export const findAvatarById = (
    id: string,
    params?: FindAvatarByIdParams,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<AvatarResponseResponse>(
    {url: `/api/userAvatars/${id}`, method: 'GET',
        params
    },
    options);
  }



export const getFindAvatarByIdKey = (id: string,
    params?: FindAvatarByIdParams,) => [`/api/userAvatars/${id}`, ...(params ? [params]: [])] as const;

export type FindAvatarByIdQueryResult = NonNullable<Awaited<ReturnType<typeof findAvatarById>>>
export type FindAvatarByIdQueryError = AvatarNotFoundResponseResponse

/**
 * @summary Find a Avatar by ID
 */
export const useFindAvatarById = <TError = AvatarNotFoundResponseResponse>(
  id: string,
    params?: FindAvatarByIdParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof findAvatarById>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof apiClient> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && !!(id)
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getFindAvatarByIdKey(id,params) : null);
  const swrFn = () => findAvatarById(id,params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Update a Avatar
 */
export const updateAvatar = (
    id: string,
    avatarPatchRequestBodyBody: AvatarPatchRequestBodyBody,
    params?: UpdateAvatarParams,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<AvatarResponseResponse>(
    {url: `/api/userAvatars/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: avatarPatchRequestBodyBody,
        params
    },
    options);
  }



export const getUpdateAvatarMutationFetcher = (id: string,
    params?: UpdateAvatarParams, options?: SecondParameter<typeof apiClient>) => {
  return (_: Key, { arg }: { arg: AvatarPatchRequestBodyBody }): Promise<AvatarResponseResponse> => {
    return updateAvatar(id, arg, params, options);
  }
}
export const getUpdateAvatarMutationKey = (id: string,
    params?: UpdateAvatarParams,) => [`/api/userAvatars/${id}`, ...(params ? [params]: [])] as const;

export type UpdateAvatarMutationResult = NonNullable<Awaited<ReturnType<typeof updateAvatar>>>
export type UpdateAvatarMutationError = AvatarNotFoundResponseResponse

/**
 * @summary Update a Avatar
 */
export const useUpdateAvatar = <TError = AvatarNotFoundResponseResponse>(
  id: string,
    params?: UpdateAvatarParams, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof updateAvatar>>, TError, Key, AvatarPatchRequestBodyBody, Awaited<ReturnType<typeof updateAvatar>>> & { swrKey?: string }, request?: SecondParameter<typeof apiClient>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getUpdateAvatarMutationKey(id,params);
  const swrFn = getUpdateAvatarMutationFetcher(id,params, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Delete a Avatar
 */
export const deleteAvatar = (
    id: string,
    params?: DeleteAvatarParams,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<AvatarResponseResponse>(
    {url: `/api/userAvatars/${id}`, method: 'DELETE',
        params
    },
    options);
  }



export const getDeleteAvatarMutationFetcher = (id: string,
    params?: DeleteAvatarParams, options?: SecondParameter<typeof apiClient>) => {
  return (_: Key, __: { arg: Arguments }): Promise<AvatarResponseResponse> => {
    return deleteAvatar(id, params, options);
  }
}
export const getDeleteAvatarMutationKey = (id: string,
    params?: DeleteAvatarParams,) => [`/api/userAvatars/${id}`, ...(params ? [params]: [])] as const;

export type DeleteAvatarMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAvatar>>>
export type DeleteAvatarMutationError = AvatarNotFoundResponseResponse

/**
 * @summary Delete a Avatar
 */
export const useDeleteAvatar = <TError = AvatarNotFoundResponseResponse>(
  id: string,
    params?: DeleteAvatarParams, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof deleteAvatar>>, TError, Key, Arguments, Awaited<ReturnType<typeof deleteAvatar>>> & { swrKey?: string }, request?: SecondParameter<typeof apiClient>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getDeleteAvatarMutationKey(id,params);
  const swrFn = getDeleteAvatarMutationFetcher(id,params, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Retrieve a list of Users
 */
export const listUsers = (
    params?: ListUsersParams,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<UserListResponseResponse>(
    {url: `/api/users`, method: 'GET',
        params
    },
    options);
  }



export const getListUsersKey = (params?: ListUsersParams,) => [`/api/users`, ...(params ? [params]: [])] as const;

export type ListUsersQueryResult = NonNullable<Awaited<ReturnType<typeof listUsers>>>
export type ListUsersQueryError = unknown

/**
 * @summary Retrieve a list of Users
 */
export const useListUsers = <TError = unknown>(
  params?: ListUsersParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof listUsers>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof apiClient> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getListUsersKey(params) : null);
  const swrFn = () => listUsers(params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Create a new User
 */
export const createUser = (
    userRequestBodyBody: UserRequestBodyBody,
    params?: CreateUserParams,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<NewUserResponseResponse>(
    {url: `/api/users`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: userRequestBodyBody,
        params
    },
    options);
  }



export const getCreateUserMutationFetcher = (params?: CreateUserParams, options?: SecondParameter<typeof apiClient>) => {
  return (_: Key, { arg }: { arg: UserRequestBodyBody }): Promise<NewUserResponseResponse> => {
    return createUser(arg, params, options);
  }
}
export const getCreateUserMutationKey = (params?: CreateUserParams,) => [`/api/users`, ...(params ? [params]: [])] as const;

export type CreateUserMutationResult = NonNullable<Awaited<ReturnType<typeof createUser>>>
export type CreateUserMutationError = unknown

/**
 * @summary Create a new User
 */
export const useCreateUser = <TError = unknown>(
  params?: CreateUserParams, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof createUser>>, TError, Key, UserRequestBodyBody, Awaited<ReturnType<typeof createUser>>> & { swrKey?: string }, request?: SecondParameter<typeof apiClient>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getCreateUserMutationKey(params);
  const swrFn = getCreateUserMutationFetcher(params, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Find a User by ID
 */
export const findUserById = (
    id: string,
    params?: FindUserByIdParams,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<UserResponseResponse>(
    {url: `/api/users/${id}`, method: 'GET',
        params
    },
    options);
  }



export const getFindUserByIdKey = (id: string,
    params?: FindUserByIdParams,) => [`/api/users/${id}`, ...(params ? [params]: [])] as const;

export type FindUserByIdQueryResult = NonNullable<Awaited<ReturnType<typeof findUserById>>>
export type FindUserByIdQueryError = UserNotFoundResponseResponse

/**
 * @summary Find a User by ID
 */
export const useFindUserById = <TError = UserNotFoundResponseResponse>(
  id: string,
    params?: FindUserByIdParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof findUserById>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof apiClient> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && !!(id)
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getFindUserByIdKey(id,params) : null);
  const swrFn = () => findUserById(id,params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Update a User
 */
export const updateUser = (
    id: string,
    userPatchRequestBodyBody: UserPatchRequestBodyBody,
    params?: UpdateUserParams,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<UserResponseResponse>(
    {url: `/api/users/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: userPatchRequestBodyBody,
        params
    },
    options);
  }



export const getUpdateUserMutationFetcher = (id: string,
    params?: UpdateUserParams, options?: SecondParameter<typeof apiClient>) => {
  return (_: Key, { arg }: { arg: UserPatchRequestBodyBody }): Promise<UserResponseResponse> => {
    return updateUser(id, arg, params, options);
  }
}
export const getUpdateUserMutationKey = (id: string,
    params?: UpdateUserParams,) => [`/api/users/${id}`, ...(params ? [params]: [])] as const;

export type UpdateUserMutationResult = NonNullable<Awaited<ReturnType<typeof updateUser>>>
export type UpdateUserMutationError = UserNotFoundResponseResponse

/**
 * @summary Update a User
 */
export const useUpdateUser = <TError = UserNotFoundResponseResponse>(
  id: string,
    params?: UpdateUserParams, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof updateUser>>, TError, Key, UserPatchRequestBodyBody, Awaited<ReturnType<typeof updateUser>>> & { swrKey?: string }, request?: SecondParameter<typeof apiClient>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getUpdateUserMutationKey(id,params);
  const swrFn = getUpdateUserMutationFetcher(id,params, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Delete a User
 */
export const deleteUser = (
    id: string,
    params?: DeleteUserParams,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<UserResponseResponse>(
    {url: `/api/users/${id}`, method: 'DELETE',
        params
    },
    options);
  }



export const getDeleteUserMutationFetcher = (id: string,
    params?: DeleteUserParams, options?: SecondParameter<typeof apiClient>) => {
  return (_: Key, __: { arg: Arguments }): Promise<UserResponseResponse> => {
    return deleteUser(id, params, options);
  }
}
export const getDeleteUserMutationKey = (id: string,
    params?: DeleteUserParams,) => [`/api/users/${id}`, ...(params ? [params]: [])] as const;

export type DeleteUserMutationResult = NonNullable<Awaited<ReturnType<typeof deleteUser>>>
export type DeleteUserMutationError = UserNotFoundResponseResponse

/**
 * @summary Delete a User
 */
export const useDeleteUser = <TError = UserNotFoundResponseResponse>(
  id: string,
    params?: DeleteUserParams, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof deleteUser>>, TError, Key, Arguments, Awaited<ReturnType<typeof deleteUser>>> & { swrKey?: string }, request?: SecondParameter<typeof apiClient>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getDeleteUserMutationKey(id,params);
  const swrFn = getDeleteUserMutationFetcher(id,params, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Retrieve a list of Categories
 */
export const listCategories = (
    params?: ListCategoriesParams,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<CategoryListResponseResponse>(
    {url: `/api/modelCategories`, method: 'GET',
        params
    },
    options);
  }



export const getListCategoriesKey = (params?: ListCategoriesParams,) => [`/api/modelCategories`, ...(params ? [params]: [])] as const;

export type ListCategoriesQueryResult = NonNullable<Awaited<ReturnType<typeof listCategories>>>
export type ListCategoriesQueryError = unknown

/**
 * @summary Retrieve a list of Categories
 */
export const useListCategories = <TError = unknown>(
  params?: ListCategoriesParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof listCategories>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof apiClient> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getListCategoriesKey(params) : null);
  const swrFn = () => listCategories(params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Create a new Category
 */
export const createCategory = (
    categoryRequestBodyBody: CategoryRequestBodyBody,
    params?: CreateCategoryParams,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<NewCategoryResponseResponse>(
    {url: `/api/modelCategories`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: categoryRequestBodyBody,
        params
    },
    options);
  }



export const getCreateCategoryMutationFetcher = (params?: CreateCategoryParams, options?: SecondParameter<typeof apiClient>) => {
  return (_: Key, { arg }: { arg: CategoryRequestBodyBody }): Promise<NewCategoryResponseResponse> => {
    return createCategory(arg, params, options);
  }
}
export const getCreateCategoryMutationKey = (params?: CreateCategoryParams,) => [`/api/modelCategories`, ...(params ? [params]: [])] as const;

export type CreateCategoryMutationResult = NonNullable<Awaited<ReturnType<typeof createCategory>>>
export type CreateCategoryMutationError = unknown

/**
 * @summary Create a new Category
 */
export const useCreateCategory = <TError = unknown>(
  params?: CreateCategoryParams, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof createCategory>>, TError, Key, CategoryRequestBodyBody, Awaited<ReturnType<typeof createCategory>>> & { swrKey?: string }, request?: SecondParameter<typeof apiClient>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getCreateCategoryMutationKey(params);
  const swrFn = getCreateCategoryMutationFetcher(params, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Find a Category by ID
 */
export const findCategoryById = (
    id: string,
    params?: FindCategoryByIdParams,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<CategoryResponseResponse>(
    {url: `/api/modelCategories/${id}`, method: 'GET',
        params
    },
    options);
  }



export const getFindCategoryByIdKey = (id: string,
    params?: FindCategoryByIdParams,) => [`/api/modelCategories/${id}`, ...(params ? [params]: [])] as const;

export type FindCategoryByIdQueryResult = NonNullable<Awaited<ReturnType<typeof findCategoryById>>>
export type FindCategoryByIdQueryError = CategoryNotFoundResponseResponse

/**
 * @summary Find a Category by ID
 */
export const useFindCategoryById = <TError = CategoryNotFoundResponseResponse>(
  id: string,
    params?: FindCategoryByIdParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof findCategoryById>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof apiClient> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && !!(id)
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getFindCategoryByIdKey(id,params) : null);
  const swrFn = () => findCategoryById(id,params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Update a Category
 */
export const updateCategory = (
    id: string,
    categoryPatchRequestBodyBody: CategoryPatchRequestBodyBody,
    params?: UpdateCategoryParams,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<CategoryResponseResponse>(
    {url: `/api/modelCategories/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: categoryPatchRequestBodyBody,
        params
    },
    options);
  }



export const getUpdateCategoryMutationFetcher = (id: string,
    params?: UpdateCategoryParams, options?: SecondParameter<typeof apiClient>) => {
  return (_: Key, { arg }: { arg: CategoryPatchRequestBodyBody }): Promise<CategoryResponseResponse> => {
    return updateCategory(id, arg, params, options);
  }
}
export const getUpdateCategoryMutationKey = (id: string,
    params?: UpdateCategoryParams,) => [`/api/modelCategories/${id}`, ...(params ? [params]: [])] as const;

export type UpdateCategoryMutationResult = NonNullable<Awaited<ReturnType<typeof updateCategory>>>
export type UpdateCategoryMutationError = CategoryNotFoundResponseResponse

/**
 * @summary Update a Category
 */
export const useUpdateCategory = <TError = CategoryNotFoundResponseResponse>(
  id: string,
    params?: UpdateCategoryParams, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof updateCategory>>, TError, Key, CategoryPatchRequestBodyBody, Awaited<ReturnType<typeof updateCategory>>> & { swrKey?: string }, request?: SecondParameter<typeof apiClient>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getUpdateCategoryMutationKey(id,params);
  const swrFn = getUpdateCategoryMutationFetcher(id,params, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Delete a Category
 */
export const deleteCategory = (
    id: string,
    params?: DeleteCategoryParams,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<CategoryResponseResponse>(
    {url: `/api/modelCategories/${id}`, method: 'DELETE',
        params
    },
    options);
  }



export const getDeleteCategoryMutationFetcher = (id: string,
    params?: DeleteCategoryParams, options?: SecondParameter<typeof apiClient>) => {
  return (_: Key, __: { arg: Arguments }): Promise<CategoryResponseResponse> => {
    return deleteCategory(id, params, options);
  }
}
export const getDeleteCategoryMutationKey = (id: string,
    params?: DeleteCategoryParams,) => [`/api/modelCategories/${id}`, ...(params ? [params]: [])] as const;

export type DeleteCategoryMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCategory>>>
export type DeleteCategoryMutationError = CategoryNotFoundResponseResponse

/**
 * @summary Delete a Category
 */
export const useDeleteCategory = <TError = CategoryNotFoundResponseResponse>(
  id: string,
    params?: DeleteCategoryParams, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof deleteCategory>>, TError, Key, Arguments, Awaited<ReturnType<typeof deleteCategory>>> & { swrKey?: string }, request?: SecondParameter<typeof apiClient>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getDeleteCategoryMutationKey(id,params);
  const swrFn = getDeleteCategoryMutationFetcher(id,params, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Retrieve a list of Tags
 */
export const listTags = (
    params?: ListTagsParams,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<TagListResponseResponse>(
    {url: `/api/modelTags`, method: 'GET',
        params
    },
    options);
  }



export const getListTagsKey = (params?: ListTagsParams,) => [`/api/modelTags`, ...(params ? [params]: [])] as const;

export type ListTagsQueryResult = NonNullable<Awaited<ReturnType<typeof listTags>>>
export type ListTagsQueryError = unknown

/**
 * @summary Retrieve a list of Tags
 */
export const useListTags = <TError = unknown>(
  params?: ListTagsParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof listTags>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof apiClient> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getListTagsKey(params) : null);
  const swrFn = () => listTags(params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Create a new Tag
 */
export const createTag = (
    tagRequestBodyBody: TagRequestBodyBody,
    params?: CreateTagParams,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<NewTagResponseResponse>(
    {url: `/api/modelTags`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: tagRequestBodyBody,
        params
    },
    options);
  }



export const getCreateTagMutationFetcher = (params?: CreateTagParams, options?: SecondParameter<typeof apiClient>) => {
  return (_: Key, { arg }: { arg: TagRequestBodyBody }): Promise<NewTagResponseResponse> => {
    return createTag(arg, params, options);
  }
}
export const getCreateTagMutationKey = (params?: CreateTagParams,) => [`/api/modelTags`, ...(params ? [params]: [])] as const;

export type CreateTagMutationResult = NonNullable<Awaited<ReturnType<typeof createTag>>>
export type CreateTagMutationError = unknown

/**
 * @summary Create a new Tag
 */
export const useCreateTag = <TError = unknown>(
  params?: CreateTagParams, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof createTag>>, TError, Key, TagRequestBodyBody, Awaited<ReturnType<typeof createTag>>> & { swrKey?: string }, request?: SecondParameter<typeof apiClient>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getCreateTagMutationKey(params);
  const swrFn = getCreateTagMutationFetcher(params, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Find a Tag by ID
 */
export const findTagById = (
    id: string,
    params?: FindTagByIdParams,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<TagResponseResponse>(
    {url: `/api/modelTags/${id}`, method: 'GET',
        params
    },
    options);
  }



export const getFindTagByIdKey = (id: string,
    params?: FindTagByIdParams,) => [`/api/modelTags/${id}`, ...(params ? [params]: [])] as const;

export type FindTagByIdQueryResult = NonNullable<Awaited<ReturnType<typeof findTagById>>>
export type FindTagByIdQueryError = TagNotFoundResponseResponse

/**
 * @summary Find a Tag by ID
 */
export const useFindTagById = <TError = TagNotFoundResponseResponse>(
  id: string,
    params?: FindTagByIdParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof findTagById>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof apiClient> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && !!(id)
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getFindTagByIdKey(id,params) : null);
  const swrFn = () => findTagById(id,params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Update a Tag
 */
export const updateTag = (
    id: string,
    tagPatchRequestBodyBody: TagPatchRequestBodyBody,
    params?: UpdateTagParams,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<TagResponseResponse>(
    {url: `/api/modelTags/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: tagPatchRequestBodyBody,
        params
    },
    options);
  }



export const getUpdateTagMutationFetcher = (id: string,
    params?: UpdateTagParams, options?: SecondParameter<typeof apiClient>) => {
  return (_: Key, { arg }: { arg: TagPatchRequestBodyBody }): Promise<TagResponseResponse> => {
    return updateTag(id, arg, params, options);
  }
}
export const getUpdateTagMutationKey = (id: string,
    params?: UpdateTagParams,) => [`/api/modelTags/${id}`, ...(params ? [params]: [])] as const;

export type UpdateTagMutationResult = NonNullable<Awaited<ReturnType<typeof updateTag>>>
export type UpdateTagMutationError = TagNotFoundResponseResponse

/**
 * @summary Update a Tag
 */
export const useUpdateTag = <TError = TagNotFoundResponseResponse>(
  id: string,
    params?: UpdateTagParams, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof updateTag>>, TError, Key, TagPatchRequestBodyBody, Awaited<ReturnType<typeof updateTag>>> & { swrKey?: string }, request?: SecondParameter<typeof apiClient>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getUpdateTagMutationKey(id,params);
  const swrFn = getUpdateTagMutationFetcher(id,params, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Delete a Tag
 */
export const deleteTag = (
    id: string,
    params?: DeleteTagParams,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<TagResponseResponse>(
    {url: `/api/modelTags/${id}`, method: 'DELETE',
        params
    },
    options);
  }



export const getDeleteTagMutationFetcher = (id: string,
    params?: DeleteTagParams, options?: SecondParameter<typeof apiClient>) => {
  return (_: Key, __: { arg: Arguments }): Promise<TagResponseResponse> => {
    return deleteTag(id, params, options);
  }
}
export const getDeleteTagMutationKey = (id: string,
    params?: DeleteTagParams,) => [`/api/modelTags/${id}`, ...(params ? [params]: [])] as const;

export type DeleteTagMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTag>>>
export type DeleteTagMutationError = TagNotFoundResponseResponse

/**
 * @summary Delete a Tag
 */
export const useDeleteTag = <TError = TagNotFoundResponseResponse>(
  id: string,
    params?: DeleteTagParams, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof deleteTag>>, TError, Key, Arguments, Awaited<ReturnType<typeof deleteTag>>> & { swrKey?: string }, request?: SecondParameter<typeof apiClient>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getDeleteTagMutationKey(id,params);
  const swrFn = getDeleteTagMutationFetcher(id,params, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Retrieve a list of Images
 */
export const listImages = (
    params?: ListImagesParams,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<ImageListResponseResponse>(
    {url: `/api/modelImages`, method: 'GET',
        params
    },
    options);
  }



export const getListImagesKey = (params?: ListImagesParams,) => [`/api/modelImages`, ...(params ? [params]: [])] as const;

export type ListImagesQueryResult = NonNullable<Awaited<ReturnType<typeof listImages>>>
export type ListImagesQueryError = unknown

/**
 * @summary Retrieve a list of Images
 */
export const useListImages = <TError = unknown>(
  params?: ListImagesParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof listImages>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof apiClient> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getListImagesKey(params) : null);
  const swrFn = () => listImages(params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Create a new Image
 */
export const createImage = (
    imageRequestBodyBody: ImageRequestBodyBody,
    params?: CreateImageParams,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<NewImageResponseResponse>(
    {url: `/api/modelImages`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: imageRequestBodyBody,
        params
    },
    options);
  }



export const getCreateImageMutationFetcher = (params?: CreateImageParams, options?: SecondParameter<typeof apiClient>) => {
  return (_: Key, { arg }: { arg: ImageRequestBodyBody }): Promise<NewImageResponseResponse> => {
    return createImage(arg, params, options);
  }
}
export const getCreateImageMutationKey = (params?: CreateImageParams,) => [`/api/modelImages`, ...(params ? [params]: [])] as const;

export type CreateImageMutationResult = NonNullable<Awaited<ReturnType<typeof createImage>>>
export type CreateImageMutationError = unknown

/**
 * @summary Create a new Image
 */
export const useCreateImage = <TError = unknown>(
  params?: CreateImageParams, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof createImage>>, TError, Key, ImageRequestBodyBody, Awaited<ReturnType<typeof createImage>>> & { swrKey?: string }, request?: SecondParameter<typeof apiClient>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getCreateImageMutationKey(params);
  const swrFn = getCreateImageMutationFetcher(params, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Find a Image by ID
 */
export const findImageById = (
    id: string,
    params?: FindImageByIdParams,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<ImageResponseResponse>(
    {url: `/api/modelImages/${id}`, method: 'GET',
        params
    },
    options);
  }



export const getFindImageByIdKey = (id: string,
    params?: FindImageByIdParams,) => [`/api/modelImages/${id}`, ...(params ? [params]: [])] as const;

export type FindImageByIdQueryResult = NonNullable<Awaited<ReturnType<typeof findImageById>>>
export type FindImageByIdQueryError = ImageNotFoundResponseResponse

/**
 * @summary Find a Image by ID
 */
export const useFindImageById = <TError = ImageNotFoundResponseResponse>(
  id: string,
    params?: FindImageByIdParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof findImageById>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof apiClient> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && !!(id)
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getFindImageByIdKey(id,params) : null);
  const swrFn = () => findImageById(id,params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Update a Image
 */
export const updateImage = (
    id: string,
    imagePatchRequestBodyBody: ImagePatchRequestBodyBody,
    params?: UpdateImageParams,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<ImageResponseResponse>(
    {url: `/api/modelImages/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: imagePatchRequestBodyBody,
        params
    },
    options);
  }



export const getUpdateImageMutationFetcher = (id: string,
    params?: UpdateImageParams, options?: SecondParameter<typeof apiClient>) => {
  return (_: Key, { arg }: { arg: ImagePatchRequestBodyBody }): Promise<ImageResponseResponse> => {
    return updateImage(id, arg, params, options);
  }
}
export const getUpdateImageMutationKey = (id: string,
    params?: UpdateImageParams,) => [`/api/modelImages/${id}`, ...(params ? [params]: [])] as const;

export type UpdateImageMutationResult = NonNullable<Awaited<ReturnType<typeof updateImage>>>
export type UpdateImageMutationError = ImageNotFoundResponseResponse

/**
 * @summary Update a Image
 */
export const useUpdateImage = <TError = ImageNotFoundResponseResponse>(
  id: string,
    params?: UpdateImageParams, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof updateImage>>, TError, Key, ImagePatchRequestBodyBody, Awaited<ReturnType<typeof updateImage>>> & { swrKey?: string }, request?: SecondParameter<typeof apiClient>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getUpdateImageMutationKey(id,params);
  const swrFn = getUpdateImageMutationFetcher(id,params, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Delete a Image
 */
export const deleteImage = (
    id: string,
    params?: DeleteImageParams,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<ImageResponseResponse>(
    {url: `/api/modelImages/${id}`, method: 'DELETE',
        params
    },
    options);
  }



export const getDeleteImageMutationFetcher = (id: string,
    params?: DeleteImageParams, options?: SecondParameter<typeof apiClient>) => {
  return (_: Key, __: { arg: Arguments }): Promise<ImageResponseResponse> => {
    return deleteImage(id, params, options);
  }
}
export const getDeleteImageMutationKey = (id: string,
    params?: DeleteImageParams,) => [`/api/modelImages/${id}`, ...(params ? [params]: [])] as const;

export type DeleteImageMutationResult = NonNullable<Awaited<ReturnType<typeof deleteImage>>>
export type DeleteImageMutationError = ImageNotFoundResponseResponse

/**
 * @summary Delete a Image
 */
export const useDeleteImage = <TError = ImageNotFoundResponseResponse>(
  id: string,
    params?: DeleteImageParams, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof deleteImage>>, TError, Key, Arguments, Awaited<ReturnType<typeof deleteImage>>> & { swrKey?: string }, request?: SecondParameter<typeof apiClient>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getDeleteImageMutationKey(id,params);
  const swrFn = getDeleteImageMutationFetcher(id,params, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Retrieve a list of Models
 */
export const listModels = (
    params?: ListModelsParams,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<ModelListResponseResponse>(
    {url: `/api/models`, method: 'GET',
        params
    },
    options);
  }



export const getListModelsKey = (params?: ListModelsParams,) => [`/api/models`, ...(params ? [params]: [])] as const;

export type ListModelsQueryResult = NonNullable<Awaited<ReturnType<typeof listModels>>>
export type ListModelsQueryError = unknown

/**
 * @summary Retrieve a list of Models
 */
export const useListModels = <TError = unknown>(
  params?: ListModelsParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof listModels>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof apiClient> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getListModelsKey(params) : null);
  const swrFn = () => listModels(params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Create a new Model
 */
export const createModel = (
    modelRequestBodyBody: ModelRequestBodyBody,
    params?: CreateModelParams,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<NewModelResponseResponse>(
    {url: `/api/models`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: modelRequestBodyBody,
        params
    },
    options);
  }



export const getCreateModelMutationFetcher = (params?: CreateModelParams, options?: SecondParameter<typeof apiClient>) => {
  return (_: Key, { arg }: { arg: ModelRequestBodyBody }): Promise<NewModelResponseResponse> => {
    return createModel(arg, params, options);
  }
}
export const getCreateModelMutationKey = (params?: CreateModelParams,) => [`/api/models`, ...(params ? [params]: [])] as const;

export type CreateModelMutationResult = NonNullable<Awaited<ReturnType<typeof createModel>>>
export type CreateModelMutationError = unknown

/**
 * @summary Create a new Model
 */
export const useCreateModel = <TError = unknown>(
  params?: CreateModelParams, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof createModel>>, TError, Key, ModelRequestBodyBody, Awaited<ReturnType<typeof createModel>>> & { swrKey?: string }, request?: SecondParameter<typeof apiClient>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getCreateModelMutationKey(params);
  const swrFn = getCreateModelMutationFetcher(params, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Find a Model by ID
 */
export const findModelById = (
    id: string,
    params?: FindModelByIdParams,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<ModelResponseResponse>(
    {url: `/api/models/${id}`, method: 'GET',
        params
    },
    options);
  }



export const getFindModelByIdKey = (id: string,
    params?: FindModelByIdParams,) => [`/api/models/${id}`, ...(params ? [params]: [])] as const;

export type FindModelByIdQueryResult = NonNullable<Awaited<ReturnType<typeof findModelById>>>
export type FindModelByIdQueryError = ModelNotFoundResponseResponse

/**
 * @summary Find a Model by ID
 */
export const useFindModelById = <TError = ModelNotFoundResponseResponse>(
  id: string,
    params?: FindModelByIdParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof findModelById>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof apiClient> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && !!(id)
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getFindModelByIdKey(id,params) : null);
  const swrFn = () => findModelById(id,params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Update a Model
 */
export const updateModel = (
    id: string,
    modelPatchRequestBodyBody: ModelPatchRequestBodyBody,
    params?: UpdateModelParams,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<ModelResponseResponse>(
    {url: `/api/models/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: modelPatchRequestBodyBody,
        params
    },
    options);
  }



export const getUpdateModelMutationFetcher = (id: string,
    params?: UpdateModelParams, options?: SecondParameter<typeof apiClient>) => {
  return (_: Key, { arg }: { arg: ModelPatchRequestBodyBody }): Promise<ModelResponseResponse> => {
    return updateModel(id, arg, params, options);
  }
}
export const getUpdateModelMutationKey = (id: string,
    params?: UpdateModelParams,) => [`/api/models/${id}`, ...(params ? [params]: [])] as const;

export type UpdateModelMutationResult = NonNullable<Awaited<ReturnType<typeof updateModel>>>
export type UpdateModelMutationError = ModelNotFoundResponseResponse

/**
 * @summary Update a Model
 */
export const useUpdateModel = <TError = ModelNotFoundResponseResponse>(
  id: string,
    params?: UpdateModelParams, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof updateModel>>, TError, Key, ModelPatchRequestBodyBody, Awaited<ReturnType<typeof updateModel>>> & { swrKey?: string }, request?: SecondParameter<typeof apiClient>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getUpdateModelMutationKey(id,params);
  const swrFn = getUpdateModelMutationFetcher(id,params, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Delete a Model
 */
export const deleteModel = (
    id: string,
    params?: DeleteModelParams,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<ModelResponseResponse>(
    {url: `/api/models/${id}`, method: 'DELETE',
        params
    },
    options);
  }



export const getDeleteModelMutationFetcher = (id: string,
    params?: DeleteModelParams, options?: SecondParameter<typeof apiClient>) => {
  return (_: Key, __: { arg: Arguments }): Promise<ModelResponseResponse> => {
    return deleteModel(id, params, options);
  }
}
export const getDeleteModelMutationKey = (id: string,
    params?: DeleteModelParams,) => [`/api/models/${id}`, ...(params ? [params]: [])] as const;

export type DeleteModelMutationResult = NonNullable<Awaited<ReturnType<typeof deleteModel>>>
export type DeleteModelMutationError = ModelNotFoundResponseResponse

/**
 * @summary Delete a Model
 */
export const useDeleteModel = <TError = ModelNotFoundResponseResponse>(
  id: string,
    params?: DeleteModelParams, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof deleteModel>>, TError, Key, Arguments, Awaited<ReturnType<typeof deleteModel>>> & { swrKey?: string }, request?: SecondParameter<typeof apiClient>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getDeleteModelMutationKey(id,params);
  const swrFn = getDeleteModelMutationFetcher(id,params, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Retrieve a list of Icons
 */
export const listIcons = (
    params?: ListIconsParams,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<IconListResponseResponse>(
    {url: `/api/communityStatsImages`, method: 'GET',
        params
    },
    options);
  }



export const getListIconsKey = (params?: ListIconsParams,) => [`/api/communityStatsImages`, ...(params ? [params]: [])] as const;

export type ListIconsQueryResult = NonNullable<Awaited<ReturnType<typeof listIcons>>>
export type ListIconsQueryError = unknown

/**
 * @summary Retrieve a list of Icons
 */
export const useListIcons = <TError = unknown>(
  params?: ListIconsParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof listIcons>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof apiClient> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getListIconsKey(params) : null);
  const swrFn = () => listIcons(params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Create a new Icon
 */
export const createIcon = (
    iconRequestBodyBody: IconRequestBodyBody,
    params?: CreateIconParams,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<NewIconResponseResponse>(
    {url: `/api/communityStatsImages`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: iconRequestBodyBody,
        params
    },
    options);
  }



export const getCreateIconMutationFetcher = (params?: CreateIconParams, options?: SecondParameter<typeof apiClient>) => {
  return (_: Key, { arg }: { arg: IconRequestBodyBody }): Promise<NewIconResponseResponse> => {
    return createIcon(arg, params, options);
  }
}
export const getCreateIconMutationKey = (params?: CreateIconParams,) => [`/api/communityStatsImages`, ...(params ? [params]: [])] as const;

export type CreateIconMutationResult = NonNullable<Awaited<ReturnType<typeof createIcon>>>
export type CreateIconMutationError = unknown

/**
 * @summary Create a new Icon
 */
export const useCreateIcon = <TError = unknown>(
  params?: CreateIconParams, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof createIcon>>, TError, Key, IconRequestBodyBody, Awaited<ReturnType<typeof createIcon>>> & { swrKey?: string }, request?: SecondParameter<typeof apiClient>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getCreateIconMutationKey(params);
  const swrFn = getCreateIconMutationFetcher(params, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Find a Icon by ID
 */
export const findIconById = (
    id: string,
    params?: FindIconByIdParams,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<IconResponseResponse>(
    {url: `/api/communityStatsImages/${id}`, method: 'GET',
        params
    },
    options);
  }



export const getFindIconByIdKey = (id: string,
    params?: FindIconByIdParams,) => [`/api/communityStatsImages/${id}`, ...(params ? [params]: [])] as const;

export type FindIconByIdQueryResult = NonNullable<Awaited<ReturnType<typeof findIconById>>>
export type FindIconByIdQueryError = IconNotFoundResponseResponse

/**
 * @summary Find a Icon by ID
 */
export const useFindIconById = <TError = IconNotFoundResponseResponse>(
  id: string,
    params?: FindIconByIdParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof findIconById>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof apiClient> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && !!(id)
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getFindIconByIdKey(id,params) : null);
  const swrFn = () => findIconById(id,params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Update a Icon
 */
export const updateIcon = (
    id: string,
    iconPatchRequestBodyBody: IconPatchRequestBodyBody,
    params?: UpdateIconParams,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<IconResponseResponse>(
    {url: `/api/communityStatsImages/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: iconPatchRequestBodyBody,
        params
    },
    options);
  }



export const getUpdateIconMutationFetcher = (id: string,
    params?: UpdateIconParams, options?: SecondParameter<typeof apiClient>) => {
  return (_: Key, { arg }: { arg: IconPatchRequestBodyBody }): Promise<IconResponseResponse> => {
    return updateIcon(id, arg, params, options);
  }
}
export const getUpdateIconMutationKey = (id: string,
    params?: UpdateIconParams,) => [`/api/communityStatsImages/${id}`, ...(params ? [params]: [])] as const;

export type UpdateIconMutationResult = NonNullable<Awaited<ReturnType<typeof updateIcon>>>
export type UpdateIconMutationError = IconNotFoundResponseResponse

/**
 * @summary Update a Icon
 */
export const useUpdateIcon = <TError = IconNotFoundResponseResponse>(
  id: string,
    params?: UpdateIconParams, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof updateIcon>>, TError, Key, IconPatchRequestBodyBody, Awaited<ReturnType<typeof updateIcon>>> & { swrKey?: string }, request?: SecondParameter<typeof apiClient>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getUpdateIconMutationKey(id,params);
  const swrFn = getUpdateIconMutationFetcher(id,params, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Delete a Icon
 */
export const deleteIcon = (
    id: string,
    params?: DeleteIconParams,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<IconResponseResponse>(
    {url: `/api/communityStatsImages/${id}`, method: 'DELETE',
        params
    },
    options);
  }



export const getDeleteIconMutationFetcher = (id: string,
    params?: DeleteIconParams, options?: SecondParameter<typeof apiClient>) => {
  return (_: Key, __: { arg: Arguments }): Promise<IconResponseResponse> => {
    return deleteIcon(id, params, options);
  }
}
export const getDeleteIconMutationKey = (id: string,
    params?: DeleteIconParams,) => [`/api/communityStatsImages/${id}`, ...(params ? [params]: [])] as const;

export type DeleteIconMutationResult = NonNullable<Awaited<ReturnType<typeof deleteIcon>>>
export type DeleteIconMutationError = IconNotFoundResponseResponse

/**
 * @summary Delete a Icon
 */
export const useDeleteIcon = <TError = IconNotFoundResponseResponse>(
  id: string,
    params?: DeleteIconParams, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof deleteIcon>>, TError, Key, Arguments, Awaited<ReturnType<typeof deleteIcon>>> & { swrKey?: string }, request?: SecondParameter<typeof apiClient>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getDeleteIconMutationKey(id,params);
  const swrFn = getDeleteIconMutationFetcher(id,params, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Retrieve a list of Stats
 */
export const listStats = (
    params?: ListStatsParams,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<StatsListResponseResponse>(
    {url: `/api/communityStats`, method: 'GET',
        params
    },
    options);
  }



export const getListStatsKey = (params?: ListStatsParams,) => [`/api/communityStats`, ...(params ? [params]: [])] as const;

export type ListStatsQueryResult = NonNullable<Awaited<ReturnType<typeof listStats>>>
export type ListStatsQueryError = unknown

/**
 * @summary Retrieve a list of Stats
 */
export const useListStats = <TError = unknown>(
  params?: ListStatsParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof listStats>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof apiClient> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getListStatsKey(params) : null);
  const swrFn = () => listStats(params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Create a new Stats
 */
export const createStats = (
    statsRequestBodyBody: StatsRequestBodyBody,
    params?: CreateStatsParams,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<NewStatsResponseResponse>(
    {url: `/api/communityStats`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: statsRequestBodyBody,
        params
    },
    options);
  }



export const getCreateStatsMutationFetcher = (params?: CreateStatsParams, options?: SecondParameter<typeof apiClient>) => {
  return (_: Key, { arg }: { arg: StatsRequestBodyBody }): Promise<NewStatsResponseResponse> => {
    return createStats(arg, params, options);
  }
}
export const getCreateStatsMutationKey = (params?: CreateStatsParams,) => [`/api/communityStats`, ...(params ? [params]: [])] as const;

export type CreateStatsMutationResult = NonNullable<Awaited<ReturnType<typeof createStats>>>
export type CreateStatsMutationError = unknown

/**
 * @summary Create a new Stats
 */
export const useCreateStats = <TError = unknown>(
  params?: CreateStatsParams, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof createStats>>, TError, Key, StatsRequestBodyBody, Awaited<ReturnType<typeof createStats>>> & { swrKey?: string }, request?: SecondParameter<typeof apiClient>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getCreateStatsMutationKey(params);
  const swrFn = getCreateStatsMutationFetcher(params, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Find a Stats by ID
 */
export const findStatsById = (
    id: string,
    params?: FindStatsByIdParams,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<StatsResponseResponse>(
    {url: `/api/communityStats/${id}`, method: 'GET',
        params
    },
    options);
  }



export const getFindStatsByIdKey = (id: string,
    params?: FindStatsByIdParams,) => [`/api/communityStats/${id}`, ...(params ? [params]: [])] as const;

export type FindStatsByIdQueryResult = NonNullable<Awaited<ReturnType<typeof findStatsById>>>
export type FindStatsByIdQueryError = StatsNotFoundResponseResponse

/**
 * @summary Find a Stats by ID
 */
export const useFindStatsById = <TError = StatsNotFoundResponseResponse>(
  id: string,
    params?: FindStatsByIdParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof findStatsById>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof apiClient> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && !!(id)
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getFindStatsByIdKey(id,params) : null);
  const swrFn = () => findStatsById(id,params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Update a Stats
 */
export const updateStats = (
    id: string,
    statsPatchRequestBodyBody: StatsPatchRequestBodyBody,
    params?: UpdateStatsParams,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<StatsResponseResponse>(
    {url: `/api/communityStats/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: statsPatchRequestBodyBody,
        params
    },
    options);
  }



export const getUpdateStatsMutationFetcher = (id: string,
    params?: UpdateStatsParams, options?: SecondParameter<typeof apiClient>) => {
  return (_: Key, { arg }: { arg: StatsPatchRequestBodyBody }): Promise<StatsResponseResponse> => {
    return updateStats(id, arg, params, options);
  }
}
export const getUpdateStatsMutationKey = (id: string,
    params?: UpdateStatsParams,) => [`/api/communityStats/${id}`, ...(params ? [params]: [])] as const;

export type UpdateStatsMutationResult = NonNullable<Awaited<ReturnType<typeof updateStats>>>
export type UpdateStatsMutationError = StatsNotFoundResponseResponse

/**
 * @summary Update a Stats
 */
export const useUpdateStats = <TError = StatsNotFoundResponseResponse>(
  id: string,
    params?: UpdateStatsParams, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof updateStats>>, TError, Key, StatsPatchRequestBodyBody, Awaited<ReturnType<typeof updateStats>>> & { swrKey?: string }, request?: SecondParameter<typeof apiClient>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getUpdateStatsMutationKey(id,params);
  const swrFn = getUpdateStatsMutationFetcher(id,params, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Delete a Stats
 */
export const deleteStats = (
    id: string,
    params?: DeleteStatsParams,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<StatsResponseResponse>(
    {url: `/api/communityStats/${id}`, method: 'DELETE',
        params
    },
    options);
  }



export const getDeleteStatsMutationFetcher = (id: string,
    params?: DeleteStatsParams, options?: SecondParameter<typeof apiClient>) => {
  return (_: Key, __: { arg: Arguments }): Promise<StatsResponseResponse> => {
    return deleteStats(id, params, options);
  }
}
export const getDeleteStatsMutationKey = (id: string,
    params?: DeleteStatsParams,) => [`/api/communityStats/${id}`, ...(params ? [params]: [])] as const;

export type DeleteStatsMutationResult = NonNullable<Awaited<ReturnType<typeof deleteStats>>>
export type DeleteStatsMutationError = StatsNotFoundResponseResponse

/**
 * @summary Delete a Stats
 */
export const useDeleteStats = <TError = StatsNotFoundResponseResponse>(
  id: string,
    params?: DeleteStatsParams, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof deleteStats>>, TError, Key, Arguments, Awaited<ReturnType<typeof deleteStats>>> & { swrKey?: string }, request?: SecondParameter<typeof apiClient>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getDeleteStatsMutationKey(id,params);
  const swrFn = getDeleteStatsMutationFetcher(id,params, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Retrieve a list of Photos
 */
export const listPhotos = (
    params?: ListPhotosParams,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<PhotoListResponseResponse>(
    {url: `/api/teamMembersImages`, method: 'GET',
        params
    },
    options);
  }



export const getListPhotosKey = (params?: ListPhotosParams,) => [`/api/teamMembersImages`, ...(params ? [params]: [])] as const;

export type ListPhotosQueryResult = NonNullable<Awaited<ReturnType<typeof listPhotos>>>
export type ListPhotosQueryError = unknown

/**
 * @summary Retrieve a list of Photos
 */
export const useListPhotos = <TError = unknown>(
  params?: ListPhotosParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof listPhotos>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof apiClient> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getListPhotosKey(params) : null);
  const swrFn = () => listPhotos(params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Create a new Photo
 */
export const createPhoto = (
    photoRequestBodyBody: PhotoRequestBodyBody,
    params?: CreatePhotoParams,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<NewPhotoResponseResponse>(
    {url: `/api/teamMembersImages`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: photoRequestBodyBody,
        params
    },
    options);
  }



export const getCreatePhotoMutationFetcher = (params?: CreatePhotoParams, options?: SecondParameter<typeof apiClient>) => {
  return (_: Key, { arg }: { arg: PhotoRequestBodyBody }): Promise<NewPhotoResponseResponse> => {
    return createPhoto(arg, params, options);
  }
}
export const getCreatePhotoMutationKey = (params?: CreatePhotoParams,) => [`/api/teamMembersImages`, ...(params ? [params]: [])] as const;

export type CreatePhotoMutationResult = NonNullable<Awaited<ReturnType<typeof createPhoto>>>
export type CreatePhotoMutationError = unknown

/**
 * @summary Create a new Photo
 */
export const useCreatePhoto = <TError = unknown>(
  params?: CreatePhotoParams, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof createPhoto>>, TError, Key, PhotoRequestBodyBody, Awaited<ReturnType<typeof createPhoto>>> & { swrKey?: string }, request?: SecondParameter<typeof apiClient>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getCreatePhotoMutationKey(params);
  const swrFn = getCreatePhotoMutationFetcher(params, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Find a Photo by ID
 */
export const findPhotoById = (
    id: string,
    params?: FindPhotoByIdParams,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<PhotoResponseResponse>(
    {url: `/api/teamMembersImages/${id}`, method: 'GET',
        params
    },
    options);
  }



export const getFindPhotoByIdKey = (id: string,
    params?: FindPhotoByIdParams,) => [`/api/teamMembersImages/${id}`, ...(params ? [params]: [])] as const;

export type FindPhotoByIdQueryResult = NonNullable<Awaited<ReturnType<typeof findPhotoById>>>
export type FindPhotoByIdQueryError = PhotoNotFoundResponseResponse

/**
 * @summary Find a Photo by ID
 */
export const useFindPhotoById = <TError = PhotoNotFoundResponseResponse>(
  id: string,
    params?: FindPhotoByIdParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof findPhotoById>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof apiClient> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && !!(id)
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getFindPhotoByIdKey(id,params) : null);
  const swrFn = () => findPhotoById(id,params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Update a Photo
 */
export const updatePhoto = (
    id: string,
    photoPatchRequestBodyBody: PhotoPatchRequestBodyBody,
    params?: UpdatePhotoParams,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<PhotoResponseResponse>(
    {url: `/api/teamMembersImages/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: photoPatchRequestBodyBody,
        params
    },
    options);
  }



export const getUpdatePhotoMutationFetcher = (id: string,
    params?: UpdatePhotoParams, options?: SecondParameter<typeof apiClient>) => {
  return (_: Key, { arg }: { arg: PhotoPatchRequestBodyBody }): Promise<PhotoResponseResponse> => {
    return updatePhoto(id, arg, params, options);
  }
}
export const getUpdatePhotoMutationKey = (id: string,
    params?: UpdatePhotoParams,) => [`/api/teamMembersImages/${id}`, ...(params ? [params]: [])] as const;

export type UpdatePhotoMutationResult = NonNullable<Awaited<ReturnType<typeof updatePhoto>>>
export type UpdatePhotoMutationError = PhotoNotFoundResponseResponse

/**
 * @summary Update a Photo
 */
export const useUpdatePhoto = <TError = PhotoNotFoundResponseResponse>(
  id: string,
    params?: UpdatePhotoParams, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof updatePhoto>>, TError, Key, PhotoPatchRequestBodyBody, Awaited<ReturnType<typeof updatePhoto>>> & { swrKey?: string }, request?: SecondParameter<typeof apiClient>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getUpdatePhotoMutationKey(id,params);
  const swrFn = getUpdatePhotoMutationFetcher(id,params, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Delete a Photo
 */
export const deletePhoto = (
    id: string,
    params?: DeletePhotoParams,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<PhotoResponseResponse>(
    {url: `/api/teamMembersImages/${id}`, method: 'DELETE',
        params
    },
    options);
  }



export const getDeletePhotoMutationFetcher = (id: string,
    params?: DeletePhotoParams, options?: SecondParameter<typeof apiClient>) => {
  return (_: Key, __: { arg: Arguments }): Promise<PhotoResponseResponse> => {
    return deletePhoto(id, params, options);
  }
}
export const getDeletePhotoMutationKey = (id: string,
    params?: DeletePhotoParams,) => [`/api/teamMembersImages/${id}`, ...(params ? [params]: [])] as const;

export type DeletePhotoMutationResult = NonNullable<Awaited<ReturnType<typeof deletePhoto>>>
export type DeletePhotoMutationError = PhotoNotFoundResponseResponse

/**
 * @summary Delete a Photo
 */
export const useDeletePhoto = <TError = PhotoNotFoundResponseResponse>(
  id: string,
    params?: DeletePhotoParams, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof deletePhoto>>, TError, Key, Arguments, Awaited<ReturnType<typeof deletePhoto>>> & { swrKey?: string }, request?: SecondParameter<typeof apiClient>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getDeletePhotoMutationKey(id,params);
  const swrFn = getDeletePhotoMutationFetcher(id,params, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Retrieve a list of Members
 */
export const listMembers = (
    params?: ListMembersParams,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<MemberListResponseResponse>(
    {url: `/api/teamMembers`, method: 'GET',
        params
    },
    options);
  }



export const getListMembersKey = (params?: ListMembersParams,) => [`/api/teamMembers`, ...(params ? [params]: [])] as const;

export type ListMembersQueryResult = NonNullable<Awaited<ReturnType<typeof listMembers>>>
export type ListMembersQueryError = unknown

/**
 * @summary Retrieve a list of Members
 */
export const useListMembers = <TError = unknown>(
  params?: ListMembersParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof listMembers>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof apiClient> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getListMembersKey(params) : null);
  const swrFn = () => listMembers(params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Create a new Member
 */
export const createMember = (
    memberRequestBodyBody: MemberRequestBodyBody,
    params?: CreateMemberParams,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<NewMemberResponseResponse>(
    {url: `/api/teamMembers`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: memberRequestBodyBody,
        params
    },
    options);
  }



export const getCreateMemberMutationFetcher = (params?: CreateMemberParams, options?: SecondParameter<typeof apiClient>) => {
  return (_: Key, { arg }: { arg: MemberRequestBodyBody }): Promise<NewMemberResponseResponse> => {
    return createMember(arg, params, options);
  }
}
export const getCreateMemberMutationKey = (params?: CreateMemberParams,) => [`/api/teamMembers`, ...(params ? [params]: [])] as const;

export type CreateMemberMutationResult = NonNullable<Awaited<ReturnType<typeof createMember>>>
export type CreateMemberMutationError = unknown

/**
 * @summary Create a new Member
 */
export const useCreateMember = <TError = unknown>(
  params?: CreateMemberParams, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof createMember>>, TError, Key, MemberRequestBodyBody, Awaited<ReturnType<typeof createMember>>> & { swrKey?: string }, request?: SecondParameter<typeof apiClient>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getCreateMemberMutationKey(params);
  const swrFn = getCreateMemberMutationFetcher(params, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Find a Member by ID
 */
export const findMemberById = (
    id: string,
    params?: FindMemberByIdParams,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<MemberResponseResponse>(
    {url: `/api/teamMembers/${id}`, method: 'GET',
        params
    },
    options);
  }



export const getFindMemberByIdKey = (id: string,
    params?: FindMemberByIdParams,) => [`/api/teamMembers/${id}`, ...(params ? [params]: [])] as const;

export type FindMemberByIdQueryResult = NonNullable<Awaited<ReturnType<typeof findMemberById>>>
export type FindMemberByIdQueryError = MemberNotFoundResponseResponse

/**
 * @summary Find a Member by ID
 */
export const useFindMemberById = <TError = MemberNotFoundResponseResponse>(
  id: string,
    params?: FindMemberByIdParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof findMemberById>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof apiClient> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && !!(id)
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getFindMemberByIdKey(id,params) : null);
  const swrFn = () => findMemberById(id,params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Update a Member
 */
export const updateMember = (
    id: string,
    memberPatchRequestBodyBody: MemberPatchRequestBodyBody,
    params?: UpdateMemberParams,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<MemberResponseResponse>(
    {url: `/api/teamMembers/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: memberPatchRequestBodyBody,
        params
    },
    options);
  }



export const getUpdateMemberMutationFetcher = (id: string,
    params?: UpdateMemberParams, options?: SecondParameter<typeof apiClient>) => {
  return (_: Key, { arg }: { arg: MemberPatchRequestBodyBody }): Promise<MemberResponseResponse> => {
    return updateMember(id, arg, params, options);
  }
}
export const getUpdateMemberMutationKey = (id: string,
    params?: UpdateMemberParams,) => [`/api/teamMembers/${id}`, ...(params ? [params]: [])] as const;

export type UpdateMemberMutationResult = NonNullable<Awaited<ReturnType<typeof updateMember>>>
export type UpdateMemberMutationError = MemberNotFoundResponseResponse

/**
 * @summary Update a Member
 */
export const useUpdateMember = <TError = MemberNotFoundResponseResponse>(
  id: string,
    params?: UpdateMemberParams, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof updateMember>>, TError, Key, MemberPatchRequestBodyBody, Awaited<ReturnType<typeof updateMember>>> & { swrKey?: string }, request?: SecondParameter<typeof apiClient>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getUpdateMemberMutationKey(id,params);
  const swrFn = getUpdateMemberMutationFetcher(id,params, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Delete a Member
 */
export const deleteMember = (
    id: string,
    params?: DeleteMemberParams,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<MemberResponseResponse>(
    {url: `/api/teamMembers/${id}`, method: 'DELETE',
        params
    },
    options);
  }



export const getDeleteMemberMutationFetcher = (id: string,
    params?: DeleteMemberParams, options?: SecondParameter<typeof apiClient>) => {
  return (_: Key, __: { arg: Arguments }): Promise<MemberResponseResponse> => {
    return deleteMember(id, params, options);
  }
}
export const getDeleteMemberMutationKey = (id: string,
    params?: DeleteMemberParams,) => [`/api/teamMembers/${id}`, ...(params ? [params]: [])] as const;

export type DeleteMemberMutationResult = NonNullable<Awaited<ReturnType<typeof deleteMember>>>
export type DeleteMemberMutationError = MemberNotFoundResponseResponse

/**
 * @summary Delete a Member
 */
export const useDeleteMember = <TError = MemberNotFoundResponseResponse>(
  id: string,
    params?: DeleteMemberParams, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof deleteMember>>, TError, Key, Arguments, Awaited<ReturnType<typeof deleteMember>>> & { swrKey?: string }, request?: SecondParameter<typeof apiClient>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getDeleteMemberMutationKey(id,params);
  const swrFn = getDeleteMemberMutationFetcher(id,params, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Retrieve a list of Token Utilities
 */
export const listTokenUtilities = (
    params?: ListTokenUtilitiesParams,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<TokenUtilityListResponseResponse>(
    {url: `/api/tokenUtility`, method: 'GET',
        params
    },
    options);
  }



export const getListTokenUtilitiesKey = (params?: ListTokenUtilitiesParams,) => [`/api/tokenUtility`, ...(params ? [params]: [])] as const;

export type ListTokenUtilitiesQueryResult = NonNullable<Awaited<ReturnType<typeof listTokenUtilities>>>
export type ListTokenUtilitiesQueryError = unknown

/**
 * @summary Retrieve a list of Token Utilities
 */
export const useListTokenUtilities = <TError = unknown>(
  params?: ListTokenUtilitiesParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof listTokenUtilities>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof apiClient> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getListTokenUtilitiesKey(params) : null);
  const swrFn = () => listTokenUtilities(params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Create a new Token Utility
 */
export const createTokenUtility = (
    tokenUtilityRequestBodyBody: TokenUtilityRequestBodyBody,
    params?: CreateTokenUtilityParams,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<NewTokenUtilityResponseResponse>(
    {url: `/api/tokenUtility`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: tokenUtilityRequestBodyBody,
        params
    },
    options);
  }



export const getCreateTokenUtilityMutationFetcher = (params?: CreateTokenUtilityParams, options?: SecondParameter<typeof apiClient>) => {
  return (_: Key, { arg }: { arg: TokenUtilityRequestBodyBody }): Promise<NewTokenUtilityResponseResponse> => {
    return createTokenUtility(arg, params, options);
  }
}
export const getCreateTokenUtilityMutationKey = (params?: CreateTokenUtilityParams,) => [`/api/tokenUtility`, ...(params ? [params]: [])] as const;

export type CreateTokenUtilityMutationResult = NonNullable<Awaited<ReturnType<typeof createTokenUtility>>>
export type CreateTokenUtilityMutationError = unknown

/**
 * @summary Create a new Token Utility
 */
export const useCreateTokenUtility = <TError = unknown>(
  params?: CreateTokenUtilityParams, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof createTokenUtility>>, TError, Key, TokenUtilityRequestBodyBody, Awaited<ReturnType<typeof createTokenUtility>>> & { swrKey?: string }, request?: SecondParameter<typeof apiClient>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getCreateTokenUtilityMutationKey(params);
  const swrFn = getCreateTokenUtilityMutationFetcher(params, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Find a Token Utility by ID
 */
export const findTokenUtilityById = (
    id: string,
    params?: FindTokenUtilityByIdParams,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<TokenUtilityResponseResponse>(
    {url: `/api/tokenUtility/${id}`, method: 'GET',
        params
    },
    options);
  }



export const getFindTokenUtilityByIdKey = (id: string,
    params?: FindTokenUtilityByIdParams,) => [`/api/tokenUtility/${id}`, ...(params ? [params]: [])] as const;

export type FindTokenUtilityByIdQueryResult = NonNullable<Awaited<ReturnType<typeof findTokenUtilityById>>>
export type FindTokenUtilityByIdQueryError = TokenUtilityNotFoundResponseResponse

/**
 * @summary Find a Token Utility by ID
 */
export const useFindTokenUtilityById = <TError = TokenUtilityNotFoundResponseResponse>(
  id: string,
    params?: FindTokenUtilityByIdParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof findTokenUtilityById>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof apiClient> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && !!(id)
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getFindTokenUtilityByIdKey(id,params) : null);
  const swrFn = () => findTokenUtilityById(id,params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Update a Token Utility
 */
export const updateTokenUtility = (
    id: string,
    tokenUtilityPatchRequestBodyBody: TokenUtilityPatchRequestBodyBody,
    params?: UpdateTokenUtilityParams,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<TokenUtilityResponseResponse>(
    {url: `/api/tokenUtility/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: tokenUtilityPatchRequestBodyBody,
        params
    },
    options);
  }



export const getUpdateTokenUtilityMutationFetcher = (id: string,
    params?: UpdateTokenUtilityParams, options?: SecondParameter<typeof apiClient>) => {
  return (_: Key, { arg }: { arg: TokenUtilityPatchRequestBodyBody }): Promise<TokenUtilityResponseResponse> => {
    return updateTokenUtility(id, arg, params, options);
  }
}
export const getUpdateTokenUtilityMutationKey = (id: string,
    params?: UpdateTokenUtilityParams,) => [`/api/tokenUtility/${id}`, ...(params ? [params]: [])] as const;

export type UpdateTokenUtilityMutationResult = NonNullable<Awaited<ReturnType<typeof updateTokenUtility>>>
export type UpdateTokenUtilityMutationError = TokenUtilityNotFoundResponseResponse

/**
 * @summary Update a Token Utility
 */
export const useUpdateTokenUtility = <TError = TokenUtilityNotFoundResponseResponse>(
  id: string,
    params?: UpdateTokenUtilityParams, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof updateTokenUtility>>, TError, Key, TokenUtilityPatchRequestBodyBody, Awaited<ReturnType<typeof updateTokenUtility>>> & { swrKey?: string }, request?: SecondParameter<typeof apiClient>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getUpdateTokenUtilityMutationKey(id,params);
  const swrFn = getUpdateTokenUtilityMutationFetcher(id,params, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Delete a Token Utility
 */
export const deleteTokenUtility = (
    id: string,
    params?: DeleteTokenUtilityParams,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<TokenUtilityResponseResponse>(
    {url: `/api/tokenUtility/${id}`, method: 'DELETE',
        params
    },
    options);
  }



export const getDeleteTokenUtilityMutationFetcher = (id: string,
    params?: DeleteTokenUtilityParams, options?: SecondParameter<typeof apiClient>) => {
  return (_: Key, __: { arg: Arguments }): Promise<TokenUtilityResponseResponse> => {
    return deleteTokenUtility(id, params, options);
  }
}
export const getDeleteTokenUtilityMutationKey = (id: string,
    params?: DeleteTokenUtilityParams,) => [`/api/tokenUtility/${id}`, ...(params ? [params]: [])] as const;

export type DeleteTokenUtilityMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTokenUtility>>>
export type DeleteTokenUtilityMutationError = TokenUtilityNotFoundResponseResponse

/**
 * @summary Delete a Token Utility
 */
export const useDeleteTokenUtility = <TError = TokenUtilityNotFoundResponseResponse>(
  id: string,
    params?: DeleteTokenUtilityParams, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof deleteTokenUtility>>, TError, Key, Arguments, Awaited<ReturnType<typeof deleteTokenUtility>>> & { swrKey?: string }, request?: SecondParameter<typeof apiClient>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getDeleteTokenUtilityMutationKey(id,params);
  const swrFn = getDeleteTokenUtilityMutationFetcher(id,params, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Retrieve a list of Premium Subscriptions
 */
export const listPremiumSubscriptions = (
    params?: ListPremiumSubscriptionsParams,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<PremiumSubscriptionListResponseResponse>(
    {url: `/api/premiumSubscriptions`, method: 'GET',
        params
    },
    options);
  }



export const getListPremiumSubscriptionsKey = (params?: ListPremiumSubscriptionsParams,) => [`/api/premiumSubscriptions`, ...(params ? [params]: [])] as const;

export type ListPremiumSubscriptionsQueryResult = NonNullable<Awaited<ReturnType<typeof listPremiumSubscriptions>>>
export type ListPremiumSubscriptionsQueryError = unknown

/**
 * @summary Retrieve a list of Premium Subscriptions
 */
export const useListPremiumSubscriptions = <TError = unknown>(
  params?: ListPremiumSubscriptionsParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof listPremiumSubscriptions>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof apiClient> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getListPremiumSubscriptionsKey(params) : null);
  const swrFn = () => listPremiumSubscriptions(params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Create a new Premium Subscription
 */
export const createPremiumSubscription = (
    premiumSubscriptionRequestBodyBody: PremiumSubscriptionRequestBodyBody,
    params?: CreatePremiumSubscriptionParams,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<NewPremiumSubscriptionResponseResponse>(
    {url: `/api/premiumSubscriptions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: premiumSubscriptionRequestBodyBody,
        params
    },
    options);
  }



export const getCreatePremiumSubscriptionMutationFetcher = (params?: CreatePremiumSubscriptionParams, options?: SecondParameter<typeof apiClient>) => {
  return (_: Key, { arg }: { arg: PremiumSubscriptionRequestBodyBody }): Promise<NewPremiumSubscriptionResponseResponse> => {
    return createPremiumSubscription(arg, params, options);
  }
}
export const getCreatePremiumSubscriptionMutationKey = (params?: CreatePremiumSubscriptionParams,) => [`/api/premiumSubscriptions`, ...(params ? [params]: [])] as const;

export type CreatePremiumSubscriptionMutationResult = NonNullable<Awaited<ReturnType<typeof createPremiumSubscription>>>
export type CreatePremiumSubscriptionMutationError = unknown

/**
 * @summary Create a new Premium Subscription
 */
export const useCreatePremiumSubscription = <TError = unknown>(
  params?: CreatePremiumSubscriptionParams, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof createPremiumSubscription>>, TError, Key, PremiumSubscriptionRequestBodyBody, Awaited<ReturnType<typeof createPremiumSubscription>>> & { swrKey?: string }, request?: SecondParameter<typeof apiClient>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getCreatePremiumSubscriptionMutationKey(params);
  const swrFn = getCreatePremiumSubscriptionMutationFetcher(params, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Find a Premium Subscription by ID
 */
export const findPremiumSubscriptionById = (
    id: string,
    params?: FindPremiumSubscriptionByIdParams,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<PremiumSubscriptionResponseResponse>(
    {url: `/api/premiumSubscriptions/${id}`, method: 'GET',
        params
    },
    options);
  }



export const getFindPremiumSubscriptionByIdKey = (id: string,
    params?: FindPremiumSubscriptionByIdParams,) => [`/api/premiumSubscriptions/${id}`, ...(params ? [params]: [])] as const;

export type FindPremiumSubscriptionByIdQueryResult = NonNullable<Awaited<ReturnType<typeof findPremiumSubscriptionById>>>
export type FindPremiumSubscriptionByIdQueryError = PremiumSubscriptionNotFoundResponseResponse

/**
 * @summary Find a Premium Subscription by ID
 */
export const useFindPremiumSubscriptionById = <TError = PremiumSubscriptionNotFoundResponseResponse>(
  id: string,
    params?: FindPremiumSubscriptionByIdParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof findPremiumSubscriptionById>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof apiClient> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && !!(id)
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getFindPremiumSubscriptionByIdKey(id,params) : null);
  const swrFn = () => findPremiumSubscriptionById(id,params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Update a Premium Subscription
 */
export const updatePremiumSubscription = (
    id: string,
    premiumSubscriptionPatchRequestBodyBody: PremiumSubscriptionPatchRequestBodyBody,
    params?: UpdatePremiumSubscriptionParams,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<PremiumSubscriptionResponseResponse>(
    {url: `/api/premiumSubscriptions/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: premiumSubscriptionPatchRequestBodyBody,
        params
    },
    options);
  }



export const getUpdatePremiumSubscriptionMutationFetcher = (id: string,
    params?: UpdatePremiumSubscriptionParams, options?: SecondParameter<typeof apiClient>) => {
  return (_: Key, { arg }: { arg: PremiumSubscriptionPatchRequestBodyBody }): Promise<PremiumSubscriptionResponseResponse> => {
    return updatePremiumSubscription(id, arg, params, options);
  }
}
export const getUpdatePremiumSubscriptionMutationKey = (id: string,
    params?: UpdatePremiumSubscriptionParams,) => [`/api/premiumSubscriptions/${id}`, ...(params ? [params]: [])] as const;

export type UpdatePremiumSubscriptionMutationResult = NonNullable<Awaited<ReturnType<typeof updatePremiumSubscription>>>
export type UpdatePremiumSubscriptionMutationError = PremiumSubscriptionNotFoundResponseResponse

/**
 * @summary Update a Premium Subscription
 */
export const useUpdatePremiumSubscription = <TError = PremiumSubscriptionNotFoundResponseResponse>(
  id: string,
    params?: UpdatePremiumSubscriptionParams, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof updatePremiumSubscription>>, TError, Key, PremiumSubscriptionPatchRequestBodyBody, Awaited<ReturnType<typeof updatePremiumSubscription>>> & { swrKey?: string }, request?: SecondParameter<typeof apiClient>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getUpdatePremiumSubscriptionMutationKey(id,params);
  const swrFn = getUpdatePremiumSubscriptionMutationFetcher(id,params, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Delete a Premium Subscription
 */
export const deletePremiumSubscription = (
    id: string,
    params?: DeletePremiumSubscriptionParams,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<PremiumSubscriptionResponseResponse>(
    {url: `/api/premiumSubscriptions/${id}`, method: 'DELETE',
        params
    },
    options);
  }



export const getDeletePremiumSubscriptionMutationFetcher = (id: string,
    params?: DeletePremiumSubscriptionParams, options?: SecondParameter<typeof apiClient>) => {
  return (_: Key, __: { arg: Arguments }): Promise<PremiumSubscriptionResponseResponse> => {
    return deletePremiumSubscription(id, params, options);
  }
}
export const getDeletePremiumSubscriptionMutationKey = (id: string,
    params?: DeletePremiumSubscriptionParams,) => [`/api/premiumSubscriptions/${id}`, ...(params ? [params]: [])] as const;

export type DeletePremiumSubscriptionMutationResult = NonNullable<Awaited<ReturnType<typeof deletePremiumSubscription>>>
export type DeletePremiumSubscriptionMutationError = PremiumSubscriptionNotFoundResponseResponse

/**
 * @summary Delete a Premium Subscription
 */
export const useDeletePremiumSubscription = <TError = PremiumSubscriptionNotFoundResponseResponse>(
  id: string,
    params?: DeletePremiumSubscriptionParams, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof deletePremiumSubscription>>, TError, Key, Arguments, Awaited<ReturnType<typeof deletePremiumSubscription>>> & { swrKey?: string }, request?: SecondParameter<typeof apiClient>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getDeletePremiumSubscriptionMutationKey(id,params);
  const swrFn = getDeletePremiumSubscriptionMutationFetcher(id,params, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Retrieve a list of Payload Kvs
 */
export const listPayloadKvs = (
    params?: ListPayloadKvsParams,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<PayloadKvListResponseResponse>(
    {url: `/api/payload-kv`, method: 'GET',
        params
    },
    options);
  }



export const getListPayloadKvsKey = (params?: ListPayloadKvsParams,) => [`/api/payload-kv`, ...(params ? [params]: [])] as const;

export type ListPayloadKvsQueryResult = NonNullable<Awaited<ReturnType<typeof listPayloadKvs>>>
export type ListPayloadKvsQueryError = unknown

/**
 * @summary Retrieve a list of Payload Kvs
 */
export const useListPayloadKvs = <TError = unknown>(
  params?: ListPayloadKvsParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof listPayloadKvs>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof apiClient> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getListPayloadKvsKey(params) : null);
  const swrFn = () => listPayloadKvs(params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Create a new Payload Kv
 */
export const createPayloadKv = (
    payloadKvRequestBodyBody: PayloadKvRequestBodyBody,
    params?: CreatePayloadKvParams,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<NewPayloadKvResponseResponse>(
    {url: `/api/payload-kv`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: payloadKvRequestBodyBody,
        params
    },
    options);
  }



export const getCreatePayloadKvMutationFetcher = (params?: CreatePayloadKvParams, options?: SecondParameter<typeof apiClient>) => {
  return (_: Key, { arg }: { arg: PayloadKvRequestBodyBody }): Promise<NewPayloadKvResponseResponse> => {
    return createPayloadKv(arg, params, options);
  }
}
export const getCreatePayloadKvMutationKey = (params?: CreatePayloadKvParams,) => [`/api/payload-kv`, ...(params ? [params]: [])] as const;

export type CreatePayloadKvMutationResult = NonNullable<Awaited<ReturnType<typeof createPayloadKv>>>
export type CreatePayloadKvMutationError = unknown

/**
 * @summary Create a new Payload Kv
 */
export const useCreatePayloadKv = <TError = unknown>(
  params?: CreatePayloadKvParams, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof createPayloadKv>>, TError, Key, PayloadKvRequestBodyBody, Awaited<ReturnType<typeof createPayloadKv>>> & { swrKey?: string }, request?: SecondParameter<typeof apiClient>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getCreatePayloadKvMutationKey(params);
  const swrFn = getCreatePayloadKvMutationFetcher(params, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Find a Payload Kv by ID
 */
export const findPayloadKvById = (
    id: string,
    params?: FindPayloadKvByIdParams,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<PayloadKvResponseResponse>(
    {url: `/api/payload-kv/${id}`, method: 'GET',
        params
    },
    options);
  }



export const getFindPayloadKvByIdKey = (id: string,
    params?: FindPayloadKvByIdParams,) => [`/api/payload-kv/${id}`, ...(params ? [params]: [])] as const;

export type FindPayloadKvByIdQueryResult = NonNullable<Awaited<ReturnType<typeof findPayloadKvById>>>
export type FindPayloadKvByIdQueryError = PayloadKvNotFoundResponseResponse

/**
 * @summary Find a Payload Kv by ID
 */
export const useFindPayloadKvById = <TError = PayloadKvNotFoundResponseResponse>(
  id: string,
    params?: FindPayloadKvByIdParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof findPayloadKvById>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof apiClient> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && !!(id)
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getFindPayloadKvByIdKey(id,params) : null);
  const swrFn = () => findPayloadKvById(id,params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Update a Payload Kv
 */
export const updatePayloadKv = (
    id: string,
    payloadKvPatchRequestBodyBody: PayloadKvPatchRequestBodyBody,
    params?: UpdatePayloadKvParams,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<PayloadKvResponseResponse>(
    {url: `/api/payload-kv/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: payloadKvPatchRequestBodyBody,
        params
    },
    options);
  }



export const getUpdatePayloadKvMutationFetcher = (id: string,
    params?: UpdatePayloadKvParams, options?: SecondParameter<typeof apiClient>) => {
  return (_: Key, { arg }: { arg: PayloadKvPatchRequestBodyBody }): Promise<PayloadKvResponseResponse> => {
    return updatePayloadKv(id, arg, params, options);
  }
}
export const getUpdatePayloadKvMutationKey = (id: string,
    params?: UpdatePayloadKvParams,) => [`/api/payload-kv/${id}`, ...(params ? [params]: [])] as const;

export type UpdatePayloadKvMutationResult = NonNullable<Awaited<ReturnType<typeof updatePayloadKv>>>
export type UpdatePayloadKvMutationError = PayloadKvNotFoundResponseResponse

/**
 * @summary Update a Payload Kv
 */
export const useUpdatePayloadKv = <TError = PayloadKvNotFoundResponseResponse>(
  id: string,
    params?: UpdatePayloadKvParams, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof updatePayloadKv>>, TError, Key, PayloadKvPatchRequestBodyBody, Awaited<ReturnType<typeof updatePayloadKv>>> & { swrKey?: string }, request?: SecondParameter<typeof apiClient>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getUpdatePayloadKvMutationKey(id,params);
  const swrFn = getUpdatePayloadKvMutationFetcher(id,params, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Delete a Payload Kv
 */
export const deletePayloadKv = (
    id: string,
    params?: DeletePayloadKvParams,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<PayloadKvResponseResponse>(
    {url: `/api/payload-kv/${id}`, method: 'DELETE',
        params
    },
    options);
  }



export const getDeletePayloadKvMutationFetcher = (id: string,
    params?: DeletePayloadKvParams, options?: SecondParameter<typeof apiClient>) => {
  return (_: Key, __: { arg: Arguments }): Promise<PayloadKvResponseResponse> => {
    return deletePayloadKv(id, params, options);
  }
}
export const getDeletePayloadKvMutationKey = (id: string,
    params?: DeletePayloadKvParams,) => [`/api/payload-kv/${id}`, ...(params ? [params]: [])] as const;

export type DeletePayloadKvMutationResult = NonNullable<Awaited<ReturnType<typeof deletePayloadKv>>>
export type DeletePayloadKvMutationError = PayloadKvNotFoundResponseResponse

/**
 * @summary Delete a Payload Kv
 */
export const useDeletePayloadKv = <TError = PayloadKvNotFoundResponseResponse>(
  id: string,
    params?: DeletePayloadKvParams, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof deletePayloadKv>>, TError, Key, Arguments, Awaited<ReturnType<typeof deletePayloadKv>>> & { swrKey?: string }, request?: SecondParameter<typeof apiClient>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getDeletePayloadKvMutationKey(id,params);
  const swrFn = getDeletePayloadKvMutationFetcher(id,params, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Retrieve a list of Payload Locked Documents
 */
export const listPayloadLockedDocuments = (
    params?: ListPayloadLockedDocumentsParams,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<PayloadLockedDocumentListResponseResponse>(
    {url: `/api/payload-locked-documents`, method: 'GET',
        params
    },
    options);
  }



export const getListPayloadLockedDocumentsKey = (params?: ListPayloadLockedDocumentsParams,) => [`/api/payload-locked-documents`, ...(params ? [params]: [])] as const;

export type ListPayloadLockedDocumentsQueryResult = NonNullable<Awaited<ReturnType<typeof listPayloadLockedDocuments>>>
export type ListPayloadLockedDocumentsQueryError = unknown

/**
 * @summary Retrieve a list of Payload Locked Documents
 */
export const useListPayloadLockedDocuments = <TError = unknown>(
  params?: ListPayloadLockedDocumentsParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof listPayloadLockedDocuments>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof apiClient> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getListPayloadLockedDocumentsKey(params) : null);
  const swrFn = () => listPayloadLockedDocuments(params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Create a new Payload Locked Document
 */
export const createPayloadLockedDocument = (
    payloadLockedDocumentRequestBodyBody: PayloadLockedDocumentRequestBodyBody,
    params?: CreatePayloadLockedDocumentParams,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<NewPayloadLockedDocumentResponseResponse>(
    {url: `/api/payload-locked-documents`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: payloadLockedDocumentRequestBodyBody,
        params
    },
    options);
  }



export const getCreatePayloadLockedDocumentMutationFetcher = (params?: CreatePayloadLockedDocumentParams, options?: SecondParameter<typeof apiClient>) => {
  return (_: Key, { arg }: { arg: PayloadLockedDocumentRequestBodyBody }): Promise<NewPayloadLockedDocumentResponseResponse> => {
    return createPayloadLockedDocument(arg, params, options);
  }
}
export const getCreatePayloadLockedDocumentMutationKey = (params?: CreatePayloadLockedDocumentParams,) => [`/api/payload-locked-documents`, ...(params ? [params]: [])] as const;

export type CreatePayloadLockedDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof createPayloadLockedDocument>>>
export type CreatePayloadLockedDocumentMutationError = unknown

/**
 * @summary Create a new Payload Locked Document
 */
export const useCreatePayloadLockedDocument = <TError = unknown>(
  params?: CreatePayloadLockedDocumentParams, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof createPayloadLockedDocument>>, TError, Key, PayloadLockedDocumentRequestBodyBody, Awaited<ReturnType<typeof createPayloadLockedDocument>>> & { swrKey?: string }, request?: SecondParameter<typeof apiClient>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getCreatePayloadLockedDocumentMutationKey(params);
  const swrFn = getCreatePayloadLockedDocumentMutationFetcher(params, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Find a Payload Locked Document by ID
 */
export const findPayloadLockedDocumentById = (
    id: string,
    params?: FindPayloadLockedDocumentByIdParams,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<PayloadLockedDocumentResponseResponse>(
    {url: `/api/payload-locked-documents/${id}`, method: 'GET',
        params
    },
    options);
  }



export const getFindPayloadLockedDocumentByIdKey = (id: string,
    params?: FindPayloadLockedDocumentByIdParams,) => [`/api/payload-locked-documents/${id}`, ...(params ? [params]: [])] as const;

export type FindPayloadLockedDocumentByIdQueryResult = NonNullable<Awaited<ReturnType<typeof findPayloadLockedDocumentById>>>
export type FindPayloadLockedDocumentByIdQueryError = PayloadLockedDocumentNotFoundResponseResponse

/**
 * @summary Find a Payload Locked Document by ID
 */
export const useFindPayloadLockedDocumentById = <TError = PayloadLockedDocumentNotFoundResponseResponse>(
  id: string,
    params?: FindPayloadLockedDocumentByIdParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof findPayloadLockedDocumentById>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof apiClient> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && !!(id)
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getFindPayloadLockedDocumentByIdKey(id,params) : null);
  const swrFn = () => findPayloadLockedDocumentById(id,params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Update a Payload Locked Document
 */
export const updatePayloadLockedDocument = (
    id: string,
    payloadLockedDocumentPatchRequestBodyBody: PayloadLockedDocumentPatchRequestBodyBody,
    params?: UpdatePayloadLockedDocumentParams,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<PayloadLockedDocumentResponseResponse>(
    {url: `/api/payload-locked-documents/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: payloadLockedDocumentPatchRequestBodyBody,
        params
    },
    options);
  }



export const getUpdatePayloadLockedDocumentMutationFetcher = (id: string,
    params?: UpdatePayloadLockedDocumentParams, options?: SecondParameter<typeof apiClient>) => {
  return (_: Key, { arg }: { arg: PayloadLockedDocumentPatchRequestBodyBody }): Promise<PayloadLockedDocumentResponseResponse> => {
    return updatePayloadLockedDocument(id, arg, params, options);
  }
}
export const getUpdatePayloadLockedDocumentMutationKey = (id: string,
    params?: UpdatePayloadLockedDocumentParams,) => [`/api/payload-locked-documents/${id}`, ...(params ? [params]: [])] as const;

export type UpdatePayloadLockedDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof updatePayloadLockedDocument>>>
export type UpdatePayloadLockedDocumentMutationError = PayloadLockedDocumentNotFoundResponseResponse

/**
 * @summary Update a Payload Locked Document
 */
export const useUpdatePayloadLockedDocument = <TError = PayloadLockedDocumentNotFoundResponseResponse>(
  id: string,
    params?: UpdatePayloadLockedDocumentParams, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof updatePayloadLockedDocument>>, TError, Key, PayloadLockedDocumentPatchRequestBodyBody, Awaited<ReturnType<typeof updatePayloadLockedDocument>>> & { swrKey?: string }, request?: SecondParameter<typeof apiClient>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getUpdatePayloadLockedDocumentMutationKey(id,params);
  const swrFn = getUpdatePayloadLockedDocumentMutationFetcher(id,params, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Delete a Payload Locked Document
 */
export const deletePayloadLockedDocument = (
    id: string,
    params?: DeletePayloadLockedDocumentParams,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<PayloadLockedDocumentResponseResponse>(
    {url: `/api/payload-locked-documents/${id}`, method: 'DELETE',
        params
    },
    options);
  }



export const getDeletePayloadLockedDocumentMutationFetcher = (id: string,
    params?: DeletePayloadLockedDocumentParams, options?: SecondParameter<typeof apiClient>) => {
  return (_: Key, __: { arg: Arguments }): Promise<PayloadLockedDocumentResponseResponse> => {
    return deletePayloadLockedDocument(id, params, options);
  }
}
export const getDeletePayloadLockedDocumentMutationKey = (id: string,
    params?: DeletePayloadLockedDocumentParams,) => [`/api/payload-locked-documents/${id}`, ...(params ? [params]: [])] as const;

export type DeletePayloadLockedDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof deletePayloadLockedDocument>>>
export type DeletePayloadLockedDocumentMutationError = PayloadLockedDocumentNotFoundResponseResponse

/**
 * @summary Delete a Payload Locked Document
 */
export const useDeletePayloadLockedDocument = <TError = PayloadLockedDocumentNotFoundResponseResponse>(
  id: string,
    params?: DeletePayloadLockedDocumentParams, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof deletePayloadLockedDocument>>, TError, Key, Arguments, Awaited<ReturnType<typeof deletePayloadLockedDocument>>> & { swrKey?: string }, request?: SecondParameter<typeof apiClient>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getDeletePayloadLockedDocumentMutationKey(id,params);
  const swrFn = getDeletePayloadLockedDocumentMutationFetcher(id,params, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Retrieve a list of Payload Preferences
 */
export const listPayloadPreferences = (
    params?: ListPayloadPreferencesParams,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<PayloadPreferenceListResponseResponse>(
    {url: `/api/payload-preferences`, method: 'GET',
        params
    },
    options);
  }



export const getListPayloadPreferencesKey = (params?: ListPayloadPreferencesParams,) => [`/api/payload-preferences`, ...(params ? [params]: [])] as const;

export type ListPayloadPreferencesQueryResult = NonNullable<Awaited<ReturnType<typeof listPayloadPreferences>>>
export type ListPayloadPreferencesQueryError = unknown

/**
 * @summary Retrieve a list of Payload Preferences
 */
export const useListPayloadPreferences = <TError = unknown>(
  params?: ListPayloadPreferencesParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof listPayloadPreferences>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof apiClient> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getListPayloadPreferencesKey(params) : null);
  const swrFn = () => listPayloadPreferences(params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Create a new Payload Preference
 */
export const createPayloadPreference = (
    payloadPreferenceRequestBodyBody: PayloadPreferenceRequestBodyBody,
    params?: CreatePayloadPreferenceParams,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<NewPayloadPreferenceResponseResponse>(
    {url: `/api/payload-preferences`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: payloadPreferenceRequestBodyBody,
        params
    },
    options);
  }



export const getCreatePayloadPreferenceMutationFetcher = (params?: CreatePayloadPreferenceParams, options?: SecondParameter<typeof apiClient>) => {
  return (_: Key, { arg }: { arg: PayloadPreferenceRequestBodyBody }): Promise<NewPayloadPreferenceResponseResponse> => {
    return createPayloadPreference(arg, params, options);
  }
}
export const getCreatePayloadPreferenceMutationKey = (params?: CreatePayloadPreferenceParams,) => [`/api/payload-preferences`, ...(params ? [params]: [])] as const;

export type CreatePayloadPreferenceMutationResult = NonNullable<Awaited<ReturnType<typeof createPayloadPreference>>>
export type CreatePayloadPreferenceMutationError = unknown

/**
 * @summary Create a new Payload Preference
 */
export const useCreatePayloadPreference = <TError = unknown>(
  params?: CreatePayloadPreferenceParams, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof createPayloadPreference>>, TError, Key, PayloadPreferenceRequestBodyBody, Awaited<ReturnType<typeof createPayloadPreference>>> & { swrKey?: string }, request?: SecondParameter<typeof apiClient>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getCreatePayloadPreferenceMutationKey(params);
  const swrFn = getCreatePayloadPreferenceMutationFetcher(params, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Find a Payload Preference by ID
 */
export const findPayloadPreferenceById = (
    id: string,
    params?: FindPayloadPreferenceByIdParams,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<PayloadPreferenceResponseResponse>(
    {url: `/api/payload-preferences/${id}`, method: 'GET',
        params
    },
    options);
  }



export const getFindPayloadPreferenceByIdKey = (id: string,
    params?: FindPayloadPreferenceByIdParams,) => [`/api/payload-preferences/${id}`, ...(params ? [params]: [])] as const;

export type FindPayloadPreferenceByIdQueryResult = NonNullable<Awaited<ReturnType<typeof findPayloadPreferenceById>>>
export type FindPayloadPreferenceByIdQueryError = PayloadPreferenceNotFoundResponseResponse

/**
 * @summary Find a Payload Preference by ID
 */
export const useFindPayloadPreferenceById = <TError = PayloadPreferenceNotFoundResponseResponse>(
  id: string,
    params?: FindPayloadPreferenceByIdParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof findPayloadPreferenceById>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof apiClient> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && !!(id)
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getFindPayloadPreferenceByIdKey(id,params) : null);
  const swrFn = () => findPayloadPreferenceById(id,params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Update a Payload Preference
 */
export const updatePayloadPreference = (
    id: string,
    payloadPreferencePatchRequestBodyBody: PayloadPreferencePatchRequestBodyBody,
    params?: UpdatePayloadPreferenceParams,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<PayloadPreferenceResponseResponse>(
    {url: `/api/payload-preferences/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: payloadPreferencePatchRequestBodyBody,
        params
    },
    options);
  }



export const getUpdatePayloadPreferenceMutationFetcher = (id: string,
    params?: UpdatePayloadPreferenceParams, options?: SecondParameter<typeof apiClient>) => {
  return (_: Key, { arg }: { arg: PayloadPreferencePatchRequestBodyBody }): Promise<PayloadPreferenceResponseResponse> => {
    return updatePayloadPreference(id, arg, params, options);
  }
}
export const getUpdatePayloadPreferenceMutationKey = (id: string,
    params?: UpdatePayloadPreferenceParams,) => [`/api/payload-preferences/${id}`, ...(params ? [params]: [])] as const;

export type UpdatePayloadPreferenceMutationResult = NonNullable<Awaited<ReturnType<typeof updatePayloadPreference>>>
export type UpdatePayloadPreferenceMutationError = PayloadPreferenceNotFoundResponseResponse

/**
 * @summary Update a Payload Preference
 */
export const useUpdatePayloadPreference = <TError = PayloadPreferenceNotFoundResponseResponse>(
  id: string,
    params?: UpdatePayloadPreferenceParams, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof updatePayloadPreference>>, TError, Key, PayloadPreferencePatchRequestBodyBody, Awaited<ReturnType<typeof updatePayloadPreference>>> & { swrKey?: string }, request?: SecondParameter<typeof apiClient>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getUpdatePayloadPreferenceMutationKey(id,params);
  const swrFn = getUpdatePayloadPreferenceMutationFetcher(id,params, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Delete a Payload Preference
 */
export const deletePayloadPreference = (
    id: string,
    params?: DeletePayloadPreferenceParams,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<PayloadPreferenceResponseResponse>(
    {url: `/api/payload-preferences/${id}`, method: 'DELETE',
        params
    },
    options);
  }



export const getDeletePayloadPreferenceMutationFetcher = (id: string,
    params?: DeletePayloadPreferenceParams, options?: SecondParameter<typeof apiClient>) => {
  return (_: Key, __: { arg: Arguments }): Promise<PayloadPreferenceResponseResponse> => {
    return deletePayloadPreference(id, params, options);
  }
}
export const getDeletePayloadPreferenceMutationKey = (id: string,
    params?: DeletePayloadPreferenceParams,) => [`/api/payload-preferences/${id}`, ...(params ? [params]: [])] as const;

export type DeletePayloadPreferenceMutationResult = NonNullable<Awaited<ReturnType<typeof deletePayloadPreference>>>
export type DeletePayloadPreferenceMutationError = PayloadPreferenceNotFoundResponseResponse

/**
 * @summary Delete a Payload Preference
 */
export const useDeletePayloadPreference = <TError = PayloadPreferenceNotFoundResponseResponse>(
  id: string,
    params?: DeletePayloadPreferenceParams, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof deletePayloadPreference>>, TError, Key, Arguments, Awaited<ReturnType<typeof deletePayloadPreference>>> & { swrKey?: string }, request?: SecondParameter<typeof apiClient>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getDeletePayloadPreferenceMutationKey(id,params);
  const swrFn = getDeletePayloadPreferenceMutationFetcher(id,params, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Retrieve a list of Payload Migrations
 */
export const listPayloadMigrations = (
    params?: ListPayloadMigrationsParams,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<PayloadMigrationListResponseResponse>(
    {url: `/api/payload-migrations`, method: 'GET',
        params
    },
    options);
  }



export const getListPayloadMigrationsKey = (params?: ListPayloadMigrationsParams,) => [`/api/payload-migrations`, ...(params ? [params]: [])] as const;

export type ListPayloadMigrationsQueryResult = NonNullable<Awaited<ReturnType<typeof listPayloadMigrations>>>
export type ListPayloadMigrationsQueryError = unknown

/**
 * @summary Retrieve a list of Payload Migrations
 */
export const useListPayloadMigrations = <TError = unknown>(
  params?: ListPayloadMigrationsParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof listPayloadMigrations>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof apiClient> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getListPayloadMigrationsKey(params) : null);
  const swrFn = () => listPayloadMigrations(params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Create a new Payload Migration
 */
export const createPayloadMigration = (
    payloadMigrationRequestBodyBody: PayloadMigrationRequestBodyBody,
    params?: CreatePayloadMigrationParams,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<NewPayloadMigrationResponseResponse>(
    {url: `/api/payload-migrations`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: payloadMigrationRequestBodyBody,
        params
    },
    options);
  }



export const getCreatePayloadMigrationMutationFetcher = (params?: CreatePayloadMigrationParams, options?: SecondParameter<typeof apiClient>) => {
  return (_: Key, { arg }: { arg: PayloadMigrationRequestBodyBody }): Promise<NewPayloadMigrationResponseResponse> => {
    return createPayloadMigration(arg, params, options);
  }
}
export const getCreatePayloadMigrationMutationKey = (params?: CreatePayloadMigrationParams,) => [`/api/payload-migrations`, ...(params ? [params]: [])] as const;

export type CreatePayloadMigrationMutationResult = NonNullable<Awaited<ReturnType<typeof createPayloadMigration>>>
export type CreatePayloadMigrationMutationError = unknown

/**
 * @summary Create a new Payload Migration
 */
export const useCreatePayloadMigration = <TError = unknown>(
  params?: CreatePayloadMigrationParams, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof createPayloadMigration>>, TError, Key, PayloadMigrationRequestBodyBody, Awaited<ReturnType<typeof createPayloadMigration>>> & { swrKey?: string }, request?: SecondParameter<typeof apiClient>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getCreatePayloadMigrationMutationKey(params);
  const swrFn = getCreatePayloadMigrationMutationFetcher(params, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Find a Payload Migration by ID
 */
export const findPayloadMigrationById = (
    id: string,
    params?: FindPayloadMigrationByIdParams,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<PayloadMigrationResponseResponse>(
    {url: `/api/payload-migrations/${id}`, method: 'GET',
        params
    },
    options);
  }



export const getFindPayloadMigrationByIdKey = (id: string,
    params?: FindPayloadMigrationByIdParams,) => [`/api/payload-migrations/${id}`, ...(params ? [params]: [])] as const;

export type FindPayloadMigrationByIdQueryResult = NonNullable<Awaited<ReturnType<typeof findPayloadMigrationById>>>
export type FindPayloadMigrationByIdQueryError = PayloadMigrationNotFoundResponseResponse

/**
 * @summary Find a Payload Migration by ID
 */
export const useFindPayloadMigrationById = <TError = PayloadMigrationNotFoundResponseResponse>(
  id: string,
    params?: FindPayloadMigrationByIdParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof findPayloadMigrationById>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof apiClient> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && !!(id)
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getFindPayloadMigrationByIdKey(id,params) : null);
  const swrFn = () => findPayloadMigrationById(id,params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Update a Payload Migration
 */
export const updatePayloadMigration = (
    id: string,
    payloadMigrationPatchRequestBodyBody: PayloadMigrationPatchRequestBodyBody,
    params?: UpdatePayloadMigrationParams,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<PayloadMigrationResponseResponse>(
    {url: `/api/payload-migrations/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: payloadMigrationPatchRequestBodyBody,
        params
    },
    options);
  }



export const getUpdatePayloadMigrationMutationFetcher = (id: string,
    params?: UpdatePayloadMigrationParams, options?: SecondParameter<typeof apiClient>) => {
  return (_: Key, { arg }: { arg: PayloadMigrationPatchRequestBodyBody }): Promise<PayloadMigrationResponseResponse> => {
    return updatePayloadMigration(id, arg, params, options);
  }
}
export const getUpdatePayloadMigrationMutationKey = (id: string,
    params?: UpdatePayloadMigrationParams,) => [`/api/payload-migrations/${id}`, ...(params ? [params]: [])] as const;

export type UpdatePayloadMigrationMutationResult = NonNullable<Awaited<ReturnType<typeof updatePayloadMigration>>>
export type UpdatePayloadMigrationMutationError = PayloadMigrationNotFoundResponseResponse

/**
 * @summary Update a Payload Migration
 */
export const useUpdatePayloadMigration = <TError = PayloadMigrationNotFoundResponseResponse>(
  id: string,
    params?: UpdatePayloadMigrationParams, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof updatePayloadMigration>>, TError, Key, PayloadMigrationPatchRequestBodyBody, Awaited<ReturnType<typeof updatePayloadMigration>>> & { swrKey?: string }, request?: SecondParameter<typeof apiClient>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getUpdatePayloadMigrationMutationKey(id,params);
  const swrFn = getUpdatePayloadMigrationMutationFetcher(id,params, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Delete a Payload Migration
 */
export const deletePayloadMigration = (
    id: string,
    params?: DeletePayloadMigrationParams,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<PayloadMigrationResponseResponse>(
    {url: `/api/payload-migrations/${id}`, method: 'DELETE',
        params
    },
    options);
  }



export const getDeletePayloadMigrationMutationFetcher = (id: string,
    params?: DeletePayloadMigrationParams, options?: SecondParameter<typeof apiClient>) => {
  return (_: Key, __: { arg: Arguments }): Promise<PayloadMigrationResponseResponse> => {
    return deletePayloadMigration(id, params, options);
  }
}
export const getDeletePayloadMigrationMutationKey = (id: string,
    params?: DeletePayloadMigrationParams,) => [`/api/payload-migrations/${id}`, ...(params ? [params]: [])] as const;

export type DeletePayloadMigrationMutationResult = NonNullable<Awaited<ReturnType<typeof deletePayloadMigration>>>
export type DeletePayloadMigrationMutationError = PayloadMigrationNotFoundResponseResponse

/**
 * @summary Delete a Payload Migration
 */
export const useDeletePayloadMigration = <TError = PayloadMigrationNotFoundResponseResponse>(
  id: string,
    params?: DeletePayloadMigrationParams, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof deletePayloadMigration>>, TError, Key, Arguments, Awaited<ReturnType<typeof deletePayloadMigration>>> & { swrKey?: string }, request?: SecondParameter<typeof apiClient>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getDeletePayloadMigrationMutationKey(id,params);
  const swrFn = getDeletePayloadMigrationMutationFetcher(id,params, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Get the Settings
 */
export const getApiGlobalsSettings = (
    params?: GetApiGlobalsSettingsParams,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<SettingsResponseResponse>(
    {url: `/api/globals/settings`, method: 'GET',
        params
    },
    options);
  }



export const getGetApiGlobalsSettingsKey = (params?: GetApiGlobalsSettingsParams,) => [`/api/globals/settings`, ...(params ? [params]: [])] as const;

export type GetApiGlobalsSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiGlobalsSettings>>>
export type GetApiGlobalsSettingsQueryError = unknown

/**
 * @summary Get the Settings
 */
export const useGetApiGlobalsSettings = <TError = unknown>(
  params?: GetApiGlobalsSettingsParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiGlobalsSettings>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof apiClient> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiGlobalsSettingsKey(params) : null);
  const swrFn = () => getApiGlobalsSettings(params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Update the Settings
 */
export const postApiGlobalsSettings = (
    settingsRequestBodyBody: SettingsRequestBodyBody,
 options?: SecondParameter<typeof apiClient>) => {
    return apiClient<SettingsResponseResponse>(
    {url: `/api/globals/settings`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: settingsRequestBodyBody
    },
    options);
  }



export const getPostApiGlobalsSettingsMutationFetcher = ( options?: SecondParameter<typeof apiClient>) => {
  return (_: Key, { arg }: { arg: SettingsRequestBodyBody }): Promise<SettingsResponseResponse> => {
    return postApiGlobalsSettings(arg, options);
  }
}
export const getPostApiGlobalsSettingsMutationKey = () => [`/api/globals/settings`] as const;

export type PostApiGlobalsSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiGlobalsSettings>>>
export type PostApiGlobalsSettingsMutationError = unknown

/**
 * @summary Update the Settings
 */
export const usePostApiGlobalsSettings = <TError = unknown>(
   options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiGlobalsSettings>>, TError, Key, SettingsRequestBodyBody, Awaited<ReturnType<typeof postApiGlobalsSettings>>> & { swrKey?: string }, request?: SecondParameter<typeof apiClient>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiGlobalsSettingsMutationKey();
  const swrFn = getPostApiGlobalsSettingsMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, {
    
    ...swrOptions
  })

  return {
    swrKey,
    ...query
  }
}

